// This file is auto-generated by a script. Do not edit manually.

const countyPolygons = {
  "Kalamazoo County MI": [
    {
      "lng": -85.293626,
      "lat": 42.071553
    },
    {
      "lng": -85.762943,
      "lat": 42.069327
    },
    {
      "lng": -85.764352,
      "lat": 42.420669
    },
    {
      "lng": -85.543191,
      "lat": 42.421433
    },
    {
      "lng": -85.298879,
      "lat": 42.419849
    },
    {
      "lng": -85.29948,
      "lat": 42.416794
    },
    {
      "lng": -85.296996,
      "lat": 42.246071
    },
    {
      "lng": -85.293626,
      "lat": 42.071553
    }
  ],
  "Durham County NC": [
    {
      "lng": -78.749,
      "lat": 36.071246
    },
    {
      "lng": -78.750668,
      "lat": 36.030847
    },
    {
      "lng": -78.719592,
      "lat": 36.029435
    },
    {
      "lng": -78.69793,
      "lat": 36.012306
    },
    {
      "lng": -78.718679,
      "lat": 35.95806
    },
    {
      "lng": -78.759237,
      "lat": 35.918185
    },
    {
      "lng": -78.806052,
      "lat": 35.927862
    },
    {
      "lng": -78.831781,
      "lat": 35.867314
    },
    {
      "lng": -78.90617,
      "lat": 35.867912
    },
    {
      "lng": -79.016699,
      "lat": 35.863201
    },
    {
      "lng": -78.95079,
      "lat": 36.23916
    },
    {
      "lng": -78.949311,
      "lat": 36.239435
    },
    {
      "lng": -78.802005,
      "lat": 36.235937
    },
    {
      "lng": -78.804983,
      "lat": 36.091883
    },
    {
      "lng": -78.787988,
      "lat": 36.071885
    },
    {
      "lng": -78.749,
      "lat": 36.071246
    }
  ],
  "Horry County SC": [
    {
      "lng": -79.128165,
      "lat": 34.253652
    },
    {
      "lng": -79.071169,
      "lat": 34.29924
    },
    {
      "lng": -78.99576,
      "lat": 34.235954
    },
    {
      "lng": -78.963692,
      "lat": 34.209041
    },
    {
      "lng": -78.909881,
      "lat": 34.163881
    },
    {
      "lng": -78.874747,
      "lat": 34.134395
    },
    {
      "lng": -78.855385,
      "lat": 34.117996
    },
    {
      "lng": -78.81171,
      "lat": 34.081006
    },
    {
      "lng": -78.769483,
      "lat": 34.045242
    },
    {
      "lng": -78.712206,
      "lat": 33.996732
    },
    {
      "lng": -78.710141,
      "lat": 33.994688
    },
    {
      "lng": -78.702771,
      "lat": 33.989268
    },
    {
      "lng": -78.66253,
      "lat": 33.95452
    },
    {
      "lng": -78.651629,
      "lat": 33.945397
    },
    {
      "lng": -78.650329,
      "lat": 33.944309
    },
    {
      "lng": -78.621369,
      "lat": 33.920073
    },
    {
      "lng": -78.615932,
      "lat": 33.915523
    },
    {
      "lng": -78.580378,
      "lat": 33.884925
    },
    {
      "lng": -78.541087,
      "lat": 33.851112
    },
    {
      "lng": -78.553944,
      "lat": 33.847831
    },
    {
      "lng": -78.584841,
      "lat": 33.844282
    },
    {
      "lng": -78.67226,
      "lat": 33.817587
    },
    {
      "lng": -78.714116,
      "lat": 33.800138
    },
    {
      "lng": -78.772737,
      "lat": 33.768511
    },
    {
      "lng": -78.812931,
      "lat": 33.743472
    },
    {
      "lng": -78.862931,
      "lat": 33.705654
    },
    {
      "lng": -78.938076,
      "lat": 33.639826
    },
    {
      "lng": -79.002109,
      "lat": 33.572114
    },
    {
      "lng": -79.012362,
      "lat": 33.572186
    },
    {
      "lng": -79.063724,
      "lat": 33.571927
    },
    {
      "lng": -79.098393,
      "lat": 33.597146
    },
    {
      "lng": -79.120114,
      "lat": 33.607874
    },
    {
      "lng": -79.130292,
      "lat": 33.63522
    },
    {
      "lng": -79.127115,
      "lat": 33.652244
    },
    {
      "lng": -79.156308,
      "lat": 33.682938
    },
    {
      "lng": -79.190264,
      "lat": 33.705787
    },
    {
      "lng": -79.215417,
      "lat": 33.745733
    },
    {
      "lng": -79.235,
      "lat": 33.765629
    },
    {
      "lng": -79.250646,
      "lat": 33.791886
    },
    {
      "lng": -79.259083,
      "lat": 33.838251
    },
    {
      "lng": -79.262595,
      "lat": 33.884056
    },
    {
      "lng": -79.308978,
      "lat": 33.915882
    },
    {
      "lng": -79.32528,
      "lat": 33.950864
    },
    {
      "lng": -79.329802,
      "lat": 33.989694
    },
    {
      "lng": -79.310602,
      "lat": 34.003647
    },
    {
      "lng": -79.297278,
      "lat": 34.033066
    },
    {
      "lng": -79.266106,
      "lat": 34.045722
    },
    {
      "lng": -79.245169,
      "lat": 34.078017
    },
    {
      "lng": -79.230843,
      "lat": 34.10678
    },
    {
      "lng": -79.206557,
      "lat": 34.138158
    },
    {
      "lng": -79.192637,
      "lat": 34.170962
    },
    {
      "lng": -79.157641,
      "lat": 34.201683
    },
    {
      "lng": -79.135354,
      "lat": 34.218903
    },
    {
      "lng": -79.129675,
      "lat": 34.243931
    },
    {
      "lng": -79.128165,
      "lat": 34.253652
    }
  ],
  "Williamson County TX": [
    {
      "lng": -97.369539,
      "lat": 30.419563
    },
    {
      "lng": -97.373446,
      "lat": 30.416953
    },
    {
      "lng": -97.392539,
      "lat": 30.437365
    },
    {
      "lng": -97.415953,
      "lat": 30.437426
    },
    {
      "lng": -97.445628,
      "lat": 30.461404
    },
    {
      "lng": -97.466953,
      "lat": 30.46412
    },
    {
      "lng": -97.512247,
      "lat": 30.48521
    },
    {
      "lng": -97.528151,
      "lat": 30.475434
    },
    {
      "lng": -97.54412,
      "lat": 30.47961
    },
    {
      "lng": -97.576167,
      "lat": 30.501799
    },
    {
      "lng": -97.596236,
      "lat": 30.501513
    },
    {
      "lng": -97.652395,
      "lat": 30.475275
    },
    {
      "lng": -97.682893,
      "lat": 30.480066
    },
    {
      "lng": -97.688784,
      "lat": 30.461401
    },
    {
      "lng": -97.746686,
      "lat": 30.449404
    },
    {
      "lng": -97.753688,
      "lat": 30.433396
    },
    {
      "lng": -97.775211,
      "lat": 30.429993
    },
    {
      "lng": -97.779387,
      "lat": 30.438401
    },
    {
      "lng": -97.813287,
      "lat": 30.4474
    },
    {
      "lng": -97.848384,
      "lat": 30.472662
    },
    {
      "lng": -97.855765,
      "lat": 30.507401
    },
    {
      "lng": -97.871416,
      "lat": 30.522714
    },
    {
      "lng": -97.867866,
      "lat": 30.546499
    },
    {
      "lng": -97.902456,
      "lat": 30.571328
    },
    {
      "lng": -97.926985,
      "lat": 30.567654
    },
    {
      "lng": -97.915123,
      "lat": 30.580567
    },
    {
      "lng": -97.917063,
      "lat": 30.604871
    },
    {
      "lng": -97.934809,
      "lat": 30.610286
    },
    {
      "lng": -97.956734,
      "lat": 30.628249
    },
    {
      "lng": -97.977867,
      "lat": 30.622114
    },
    {
      "lng": -97.9924,
      "lat": 30.609494
    },
    {
      "lng": -98.006276,
      "lat": 30.627516
    },
    {
      "lng": -98.012741,
      "lat": 30.616767
    },
    {
      "lng": -98.036495,
      "lat": 30.611726
    },
    {
      "lng": -98.049886,
      "lat": 30.624155
    },
    {
      "lng": -97.96286,
      "lat": 30.785641
    },
    {
      "lng": -97.828512,
      "lat": 30.906188
    },
    {
      "lng": -97.764317,
      "lat": 30.898307
    },
    {
      "lng": -97.62491,
      "lat": 30.870334
    },
    {
      "lng": -97.315507,
      "lat": 30.752371
    },
    {
      "lng": -97.271418,
      "lat": 30.735692
    },
    {
      "lng": -97.155219,
      "lat": 30.457344
    },
    {
      "lng": -97.334463,
      "lat": 30.402843
    },
    {
      "lng": -97.369539,
      "lat": 30.419563
    }
  ],
  "Bell County TX": [
    {
      "lng": -97.828512,
      "lat": 30.906188
    },
    {
      "lng": -97.840365,
      "lat": 30.929318
    },
    {
      "lng": -97.911684,
      "lat": 31.034919
    },
    {
      "lng": -97.913847,
      "lat": 31.065882
    },
    {
      "lng": -97.9071,
      "lat": 31.069374
    },
    {
      "lng": -97.418606,
      "lat": 31.320202
    },
    {
      "lng": -97.343426,
      "lat": 31.244215
    },
    {
      "lng": -97.278113,
      "lat": 31.279799
    },
    {
      "lng": -97.070188,
      "lat": 30.98622
    },
    {
      "lng": -97.250274,
      "lat": 30.895137
    },
    {
      "lng": -97.259082,
      "lat": 30.889596
    },
    {
      "lng": -97.315507,
      "lat": 30.752371
    },
    {
      "lng": -97.62491,
      "lat": 30.870334
    },
    {
      "lng": -97.764317,
      "lat": 30.898307
    },
    {
      "lng": -97.828512,
      "lat": 30.906188
    }
  ],
  "New Castle County DE": [
    {
      "lng": -75.594846,
      "lat": 39.837286
    },
    {
      "lng": -75.593666,
      "lat": 39.837455
    },
    {
      "lng": -75.593082,
      "lat": 39.8375
    },
    {
      "lng": -75.5799,
      "lat": 39.838522
    },
    {
      "lng": -75.579849,
      "lat": 39.838526
    },
    {
      "lng": -75.570464,
      "lat": 39.839007
    },
    {
      "lng": -75.539346,
      "lat": 39.838211
    },
    {
      "lng": -75.518444,
      "lat": 39.836311
    },
    {
      "lng": -75.498843,
      "lat": 39.833312
    },
    {
      "lng": -75.481242,
      "lat": 39.829112
    },
    {
      "lng": -75.463341,
      "lat": 39.823812
    },
    {
      "lng": -75.45374,
      "lat": 39.820312
    },
    {
      "lng": -75.428038,
      "lat": 39.809212
    },
    {
      "lng": -75.415041,
      "lat": 39.801786
    },
    {
      "lng": -75.405337,
      "lat": 39.796213
    },
    {
      "lng": -75.437938,
      "lat": 39.783413
    },
    {
      "lng": -75.440909,
      "lat": 39.780831
    },
    {
      "lng": -75.448639,
      "lat": 39.774113
    },
    {
      "lng": -75.448135,
      "lat": 39.773969
    },
    {
      "lng": -75.447339,
      "lat": 39.773313
    },
    {
      "lng": -75.452339,
      "lat": 39.769013
    },
    {
      "lng": -75.459439,
      "lat": 39.765813
    },
    {
      "lng": -75.463339,
      "lat": 39.761213
    },
    {
      "lng": -75.463039,
      "lat": 39.758313
    },
    {
      "lng": -75.466249,
      "lat": 39.750769
    },
    {
      "lng": -75.466263,
      "lat": 39.750737
    },
    {
      "lng": -75.469239,
      "lat": 39.743613
    },
    {
      "lng": -75.474168,
      "lat": 39.735473
    },
    {
      "lng": -75.475384,
      "lat": 39.731057
    },
    {
      "lng": -75.47544,
      "lat": 39.728713
    },
    {
      "lng": -75.47724,
      "lat": 39.724713
    },
    {
      "lng": -75.477432,
      "lat": 39.720561
    },
    {
      "lng": -75.476888,
      "lat": 39.718337
    },
    {
      "lng": -75.47764,
      "lat": 39.715013
    },
    {
      "lng": -75.47894,
      "lat": 39.713813
    },
    {
      "lng": -75.481741,
      "lat": 39.714546
    },
    {
      "lng": -75.483141,
      "lat": 39.715513
    },
    {
      "lng": -75.485241,
      "lat": 39.715813
    },
    {
      "lng": -75.488553,
      "lat": 39.714833
    },
    {
      "lng": -75.491341,
      "lat": 39.711113
    },
    {
      "lng": -75.496241,
      "lat": 39.701413
    },
    {
      "lng": -75.504042,
      "lat": 39.698313
    },
    {
      "lng": -75.507162,
      "lat": 39.696961
    },
    {
      "lng": -75.509042,
      "lat": 39.694513
    },
    {
      "lng": -75.509742,
      "lat": 39.686113
    },
    {
      "lng": -75.529744,
      "lat": 39.692613
    },
    {
      "lng": -75.562246,
      "lat": 39.656712
    },
    {
      "lng": -75.587147,
      "lat": 39.651012
    },
    {
      "lng": -75.611969,
      "lat": 39.621968
    },
    {
      "lng": -75.613153,
      "lat": 39.62096
    },
    {
      "lng": -75.613377,
      "lat": 39.620288
    },
    {
      "lng": -75.614065,
      "lat": 39.61832
    },
    {
      "lng": -75.614929,
      "lat": 39.615952
    },
    {
      "lng": -75.614273,
      "lat": 39.61464
    },
    {
      "lng": -75.613345,
      "lat": 39.613056
    },
    {
      "lng": -75.613665,
      "lat": 39.61256
    },
    {
      "lng": -75.613233,
      "lat": 39.607408
    },
    {
      "lng": -75.613477,
      "lat": 39.606861
    },
    {
      "lng": -75.613473,
      "lat": 39.606832
    },
    {
      "lng": -75.613793,
      "lat": 39.606192
    },
    {
      "lng": -75.611905,
      "lat": 39.597568
    },
    {
      "lng": -75.611873,
      "lat": 39.597408
    },
    {
      "lng": -75.60464,
      "lat": 39.58992
    },
    {
      "lng": -75.603584,
      "lat": 39.58896
    },
    {
      "lng": -75.592224,
      "lat": 39.583568
    },
    {
      "lng": -75.591984,
      "lat": 39.583248
    },
    {
      "lng": -75.587744,
      "lat": 39.580672
    },
    {
      "lng": -75.5872,
      "lat": 39.580256
    },
    {
      "lng": -75.586608,
      "lat": 39.57888
    },
    {
      "lng": -75.586016,
      "lat": 39.578448
    },
    {
      "lng": -75.571599,
      "lat": 39.567728
    },
    {
      "lng": -75.570783,
      "lat": 39.56728
    },
    {
      "lng": -75.563034,
      "lat": 39.56224
    },
    {
      "lng": -75.564649,
      "lat": 39.559922
    },
    {
      "lng": -75.565636,
      "lat": 39.558509
    },
    {
      "lng": -75.569359,
      "lat": 39.540589
    },
    {
      "lng": -75.569418,
      "lat": 39.539124
    },
    {
      "lng": -75.570362,
      "lat": 39.527223
    },
    {
      "lng": -75.560728,
      "lat": 39.520472
    },
    {
      "lng": -75.566933,
      "lat": 39.508273
    },
    {
      "lng": -75.576436,
      "lat": 39.509195
    },
    {
      "lng": -75.587729,
      "lat": 39.496353
    },
    {
      "lng": -75.587729,
      "lat": 39.495369
    },
    {
      "lng": -75.593068,
      "lat": 39.479186
    },
    {
      "lng": -75.593068,
      "lat": 39.477996
    },
    {
      "lng": -75.589901,
      "lat": 39.462022
    },
    {
      "lng": -75.589439,
      "lat": 39.460812
    },
    {
      "lng": -75.580185,
      "lat": 39.450786
    },
    {
      "lng": -75.578914,
      "lat": 39.44788
    },
    {
      "lng": -75.570985,
      "lat": 39.442486
    },
    {
      "lng": -75.57183,
      "lat": 39.438897
    },
    {
      "lng": -75.55589,
      "lat": 39.430351
    },
    {
      "lng": -75.538512,
      "lat": 39.416502
    },
    {
      "lng": -75.535977,
      "lat": 39.409384
    },
    {
      "lng": -75.523583,
      "lat": 39.391583
    },
    {
      "lng": -75.521682,
      "lat": 39.387871
    },
    {
      "lng": -75.512996,
      "lat": 39.366153
    },
    {
      "lng": -75.512372,
      "lat": 39.365656
    },
    {
      "lng": -75.535008,
      "lat": 39.350891
    },
    {
      "lng": -75.552758,
      "lat": 39.353426
    },
    {
      "lng": -75.584341,
      "lat": 39.308718
    },
    {
      "lng": -75.619631,
      "lat": 39.310058
    },
    {
      "lng": -75.651159,
      "lat": 39.291594
    },
    {
      "lng": -75.714901,
      "lat": 39.299366
    },
    {
      "lng": -75.760104,
      "lat": 39.296817
    },
    {
      "lng": -75.766667,
      "lat": 39.377216
    },
    {
      "lng": -75.766693,
      "lat": 39.377537
    },
    {
      "lng": -75.779518,
      "lat": 39.534724
    },
    {
      "lng": -75.779663,
      "lat": 39.536504
    },
    {
      "lng": -75.780786,
      "lat": 39.550262
    },
    {
      "lng": -75.78689,
      "lat": 39.630575
    },
    {
      "lng": -75.78745,
      "lat": 39.637455
    },
    {
      "lng": -75.788658,
      "lat": 39.658211
    },
    {
      "lng": -75.788616,
      "lat": 39.680742
    },
    {
      "lng": -75.788658,
      "lat": 39.681911
    },
    {
      "lng": -75.788395,
      "lat": 39.700031
    },
    {
      "lng": -75.788395,
      "lat": 39.700287
    },
    {
      "lng": -75.788359,
      "lat": 39.721811
    },
    {
      "lng": -75.773558,
      "lat": 39.722411
    },
    {
      "lng": -75.766058,
      "lat": 39.737811
    },
    {
      "lng": -75.760346,
      "lat": 39.747231
    },
    {
      "lng": -75.753066,
      "lat": 39.757631
    },
    {
      "lng": -75.744394,
      "lat": 39.767855
    },
    {
      "lng": -75.736489,
      "lat": 39.775759
    },
    {
      "lng": -75.727049,
      "lat": 39.784126
    },
    {
      "lng": -75.716969,
      "lat": 39.791998
    },
    {
      "lng": -75.701208,
      "lat": 39.802606
    },
    {
      "lng": -75.685991,
      "lat": 39.811054
    },
    {
      "lng": -75.662822,
      "lat": 39.82115
    },
    {
      "lng": -75.641518,
      "lat": 39.828363
    },
    {
      "lng": -75.634706,
      "lat": 39.830164
    },
    {
      "lng": -75.617251,
      "lat": 39.833999
    },
    {
      "lng": -75.595756,
      "lat": 39.837156
    },
    {
      "lng": -75.594846,
      "lat": 39.837286
    }
  ],
  "Cherokee County GA": [
    {
      "lng": -84.653232,
      "lat": 34.41259
    },
    {
      "lng": -84.58283,
      "lat": 34.412191
    },
    {
      "lng": -84.58263,
      "lat": 34.381492
    },
    {
      "lng": -84.400724,
      "lat": 34.380492
    },
    {
      "lng": -84.392224,
      "lat": 34.373292
    },
    {
      "lng": -84.392124,
      "lat": 34.380692
    },
    {
      "lng": -84.257586,
      "lat": 34.380992
    },
    {
      "lng": -84.258075,
      "lat": 34.335156
    },
    {
      "lng": -84.258743,
      "lat": 34.185909
    },
    {
      "lng": -84.328263,
      "lat": 34.186144
    },
    {
      "lng": -84.351786,
      "lat": 34.176798
    },
    {
      "lng": -84.360533,
      "lat": 34.162319
    },
    {
      "lng": -84.361458,
      "lat": 34.125036
    },
    {
      "lng": -84.418428,
      "lat": 34.109043
    },
    {
      "lng": -84.418927,
      "lat": 34.073298
    },
    {
      "lng": -84.521992,
      "lat": 34.075399
    },
    {
      "lng": -84.659234,
      "lat": 34.077999
    },
    {
      "lng": -84.657717,
      "lat": 34.202675
    },
    {
      "lng": -84.653751,
      "lat": 34.227214
    },
    {
      "lng": -84.653998,
      "lat": 34.346934
    },
    {
      "lng": -84.644293,
      "lat": 34.355168
    },
    {
      "lng": -84.654038,
      "lat": 34.355176
    },
    {
      "lng": -84.653232,
      "lat": 34.41259
    }
  ],
  "Cobb County GA": [
    {
      "lng": -84.724435,
      "lat": 33.881859
    },
    {
      "lng": -84.723236,
      "lat": 33.947353
    },
    {
      "lng": -84.739636,
      "lat": 33.947602
    },
    {
      "lng": -84.737836,
      "lat": 34.079399
    },
    {
      "lng": -84.659234,
      "lat": 34.077999
    },
    {
      "lng": -84.521992,
      "lat": 34.075399
    },
    {
      "lng": -84.418927,
      "lat": 34.073298
    },
    {
      "lng": -84.419134,
      "lat": 34.055166
    },
    {
      "lng": -84.402385,
      "lat": 34.035249
    },
    {
      "lng": -84.401235,
      "lat": 34.014396
    },
    {
      "lng": -84.389801,
      "lat": 33.995084
    },
    {
      "lng": -84.374743,
      "lat": 33.985908
    },
    {
      "lng": -84.383027,
      "lat": 33.9638
    },
    {
      "lng": -84.418491,
      "lat": 33.931535
    },
    {
      "lng": -84.43587,
      "lat": 33.923165
    },
    {
      "lng": -84.447543,
      "lat": 33.908862
    },
    {
      "lng": -84.442708,
      "lat": 33.901543
    },
    {
      "lng": -84.443229,
      "lat": 33.878702
    },
    {
      "lng": -84.459829,
      "lat": 33.853204
    },
    {
      "lng": -84.457629,
      "lat": 33.824504
    },
    {
      "lng": -84.480134,
      "lat": 33.817319
    },
    {
      "lng": -84.538033,
      "lat": 33.771104
    },
    {
      "lng": -84.578132,
      "lat": 33.743507
    },
    {
      "lng": -84.619892,
      "lat": 33.805024
    },
    {
      "lng": -84.724139,
      "lat": 33.80617
    },
    {
      "lng": -84.723969,
      "lat": 33.815306
    },
    {
      "lng": -84.725181,
      "lat": 33.816995
    },
    {
      "lng": -84.725035,
      "lat": 33.819905
    },
    {
      "lng": -84.724435,
      "lat": 33.881859
    }
  ],
  "Kent County MI": [
    {
      "lng": -85.790448,
      "lat": 43.293003
    },
    {
      "lng": -85.571636,
      "lat": 43.294252
    },
    {
      "lng": -85.562538,
      "lat": 43.294271
    },
    {
      "lng": -85.312376,
      "lat": 43.294205
    },
    {
      "lng": -85.312513,
      "lat": 43.118793
    },
    {
      "lng": -85.309626,
      "lat": 42.769878
    },
    {
      "lng": -85.545564,
      "lat": 42.768139
    },
    {
      "lng": -85.712659,
      "lat": 42.768237
    },
    {
      "lng": -85.782498,
      "lat": 42.7682
    },
    {
      "lng": -85.783928,
      "lat": 42.943395
    },
    {
      "lng": -85.788503,
      "lat": 43.030877
    },
    {
      "lng": -85.790662,
      "lat": 43.205167
    },
    {
      "lng": -85.790448,
      "lat": 43.293003
    }
  ],
  "Ottawa County MI": [
    {
      "lng": -85.790662,
      "lat": 43.205167
    },
    {
      "lng": -85.788503,
      "lat": 43.030877
    },
    {
      "lng": -85.783928,
      "lat": 42.943395
    },
    {
      "lng": -85.782498,
      "lat": 42.7682
    },
    {
      "lng": -86.208886,
      "lat": 42.76754
    },
    {
      "lng": -86.210863,
      "lat": 42.783832
    },
    {
      "lng": -86.211815,
      "lat": 42.833236
    },
    {
      "lng": -86.210737,
      "lat": 42.859128
    },
    {
      "lng": -86.214138,
      "lat": 42.883555
    },
    {
      "lng": -86.216209,
      "lat": 42.919007
    },
    {
      "lng": -86.226305,
      "lat": 42.988284
    },
    {
      "lng": -86.232707,
      "lat": 43.015762
    },
    {
      "lng": -86.244277,
      "lat": 43.049681
    },
    {
      "lng": -86.250069,
      "lat": 43.057489
    },
    {
      "lng": -86.250517,
      "lat": 43.066993
    },
    {
      "lng": -86.254646,
      "lat": 43.083409
    },
    {
      "lng": -86.271996,
      "lat": 43.118365
    },
    {
      "lng": -85.907435,
      "lat": 43.118911
    },
    {
      "lng": -85.908388,
      "lat": 43.20592
    },
    {
      "lng": -85.790662,
      "lat": 43.205167
    }
  ],
  "Cecil County MD": [
    {
      "lng": -76.135584,
      "lat": 39.721556
    },
    {
      "lng": -76.027618,
      "lat": 39.721833
    },
    {
      "lng": -76.013067,
      "lat": 39.72192
    },
    {
      "lng": -75.998649,
      "lat": 39.721576
    },
    {
      "lng": -75.810068,
      "lat": 39.721906
    },
    {
      "lng": -75.799563,
      "lat": 39.721882
    },
    {
      "lng": -75.788359,
      "lat": 39.721811
    },
    {
      "lng": -75.788395,
      "lat": 39.700287
    },
    {
      "lng": -75.788395,
      "lat": 39.700031
    },
    {
      "lng": -75.788658,
      "lat": 39.681911
    },
    {
      "lng": -75.788616,
      "lat": 39.680742
    },
    {
      "lng": -75.788658,
      "lat": 39.658211
    },
    {
      "lng": -75.78745,
      "lat": 39.637455
    },
    {
      "lng": -75.78689,
      "lat": 39.630575
    },
    {
      "lng": -75.780786,
      "lat": 39.550262
    },
    {
      "lng": -75.779663,
      "lat": 39.536504
    },
    {
      "lng": -75.779518,
      "lat": 39.534724
    },
    {
      "lng": -75.766693,
      "lat": 39.377537
    },
    {
      "lng": -75.809817,
      "lat": 39.379768
    },
    {
      "lng": -75.816313,
      "lat": 39.380654
    },
    {
      "lng": -75.818829,
      "lat": 39.382299
    },
    {
      "lng": -75.823658,
      "lat": 39.381413
    },
    {
      "lng": -75.831173,
      "lat": 39.374173
    },
    {
      "lng": -75.842385,
      "lat": 39.370978
    },
    {
      "lng": -75.85543,
      "lat": 39.364562
    },
    {
      "lng": -75.867614,
      "lat": 39.367813
    },
    {
      "lng": -75.882141,
      "lat": 39.364322
    },
    {
      "lng": -75.885864,
      "lat": 39.360797
    },
    {
      "lng": -75.89598,
      "lat": 39.365871
    },
    {
      "lng": -75.908035,
      "lat": 39.364501
    },
    {
      "lng": -75.926589,
      "lat": 39.370994
    },
    {
      "lng": -75.939849,
      "lat": 39.367786
    },
    {
      "lng": -75.964065,
      "lat": 39.374725
    },
    {
      "lng": -75.982696,
      "lat": 39.367492
    },
    {
      "lng": -76.002463,
      "lat": 39.37644
    },
    {
      "lng": -76.002514,
      "lat": 39.384805
    },
    {
      "lng": -76.002515,
      "lat": 39.385024
    },
    {
      "lng": -76.006805,
      "lat": 39.385174
    },
    {
      "lng": -76.022304,
      "lat": 39.385716
    },
    {
      "lng": -76.035464,
      "lat": 39.386176
    },
    {
      "lng": -76.035568,
      "lat": 39.38618
    },
    {
      "lng": -76.035644,
      "lat": 39.386213
    },
    {
      "lng": -76.039279,
      "lat": 39.387796
    },
    {
      "lng": -76.039932,
      "lat": 39.38808
    },
    {
      "lng": -76.039973,
      "lat": 39.388327
    },
    {
      "lng": -76.040854,
      "lat": 39.393594
    },
    {
      "lng": -76.040962,
      "lat": 39.394237
    },
    {
      "lng": -76.040612,
      "lat": 39.394692
    },
    {
      "lng": -76.035298,
      "lat": 39.401609
    },
    {
      "lng": -76.035002,
      "lat": 39.401994
    },
    {
      "lng": -76.03472,
      "lat": 39.402093
    },
    {
      "lng": -76.018726,
      "lat": 39.407696
    },
    {
      "lng": -76.018061,
      "lat": 39.407929
    },
    {
      "lng": -76.016531,
      "lat": 39.408465
    },
    {
      "lng": -76.015763,
      "lat": 39.408947
    },
    {
      "lng": -76.012567,
      "lat": 39.410955
    },
    {
      "lng": -76.009693,
      "lat": 39.41276
    },
    {
      "lng": -76.00688,
      "lat": 39.414527
    },
    {
      "lng": -76.002856,
      "lat": 39.421225
    },
    {
      "lng": -75.998586,
      "lat": 39.428333
    },
    {
      "lng": -75.997396,
      "lat": 39.430314
    },
    {
      "lng": -75.996697,
      "lat": 39.430549
    },
    {
      "lng": -75.992742,
      "lat": 39.431877
    },
    {
      "lng": -75.992425,
      "lat": 39.431983
    },
    {
      "lng": -75.98884,
      "lat": 39.433187
    },
    {
      "lng": -75.982585,
      "lat": 39.435287
    },
    {
      "lng": -75.977751,
      "lat": 39.44302
    },
    {
      "lng": -75.976747,
      "lat": 39.444627
    },
    {
      "lng": -75.976698,
      "lat": 39.44569
    },
    {
      "lng": -75.976601,
      "lat": 39.447808
    },
    {
      "lng": -75.990005,
      "lat": 39.458646
    },
    {
      "lng": -75.990128,
      "lat": 39.458624
    },
    {
      "lng": -75.991779,
      "lat": 39.458332
    },
    {
      "lng": -75.994432,
      "lat": 39.457862
    },
    {
      "lng": -75.998276,
      "lat": 39.457182
    },
    {
      "lng": -76.002497,
      "lat": 39.450231
    },
    {
      "lng": -76.002513,
      "lat": 39.450204
    },
    {
      "lng": -76.002579,
      "lat": 39.450194
    },
    {
      "lng": -76.009071,
      "lat": 39.449256
    },
    {
      "lng": -76.009452,
      "lat": 39.449201
    },
    {
      "lng": -76.009536,
      "lat": 39.449316
    },
    {
      "lng": -76.01188,
      "lat": 39.452524
    },
    {
      "lng": -76.012312,
      "lat": 39.453115
    },
    {
      "lng": -76.011716,
      "lat": 39.454165
    },
    {
      "lng": -76.010009,
      "lat": 39.45717
    },
    {
      "lng": -76.002926,
      "lat": 39.469642
    },
    {
      "lng": -75.99657,
      "lat": 39.476658
    },
    {
      "lng": -75.995289,
      "lat": 39.483014
    },
    {
      "lng": -75.994135,
      "lat": 39.488743
    },
    {
      "lng": -75.993469,
      "lat": 39.490583
    },
    {
      "lng": -75.986298,
      "lat": 39.510398
    },
    {
      "lng": -75.985403,
      "lat": 39.512108
    },
    {
      "lng": -75.985238,
      "lat": 39.512424
    },
    {
      "lng": -75.980279,
      "lat": 39.5219
    },
    {
      "lng": -75.976105,
      "lat": 39.529876
    },
    {
      "lng": -75.976057,
      "lat": 39.529968
    },
    {
      "lng": -75.975313,
      "lat": 39.530678
    },
    {
      "lng": -75.973678,
      "lat": 39.532237
    },
    {
      "lng": -75.966955,
      "lat": 39.53865
    },
    {
      "lng": -75.966959,
      "lat": 39.538839
    },
    {
      "lng": -75.967093,
      "lat": 39.544623
    },
    {
      "lng": -75.967173,
      "lat": 39.548047
    },
    {
      "lng": -75.967186,
      "lat": 39.548627
    },
    {
      "lng": -75.967221,
      "lat": 39.55014
    },
    {
      "lng": -75.970337,
      "lat": 39.557637
    },
    {
      "lng": -75.992633,
      "lat": 39.563098
    },
    {
      "lng": -75.999669,
      "lat": 39.560488
    },
    {
      "lng": -76.00019,
      "lat": 39.559696
    },
    {
      "lng": -76.001244,
      "lat": 39.558096
    },
    {
      "lng": -76.002793,
      "lat": 39.555741
    },
    {
      "lng": -76.003434,
      "lat": 39.554768
    },
    {
      "lng": -76.004207,
      "lat": 39.553594
    },
    {
      "lng": -76.006213,
      "lat": 39.550546
    },
    {
      "lng": -76.006272,
      "lat": 39.550457
    },
    {
      "lng": -76.006341,
      "lat": 39.550352
    },
    {
      "lng": -76.03042,
      "lat": 39.548784
    },
    {
      "lng": -76.046876,
      "lat": 39.547713
    },
    {
      "lng": -76.063379,
      "lat": 39.546638
    },
    {
      "lng": -76.063811,
      "lat": 39.54661
    },
    {
      "lng": -76.075714,
      "lat": 39.543032
    },
    {
      "lng": -76.106161,
      "lat": 39.58061
    },
    {
      "lng": -76.144081,
      "lat": 39.617709
    },
    {
      "lng": -76.173575,
      "lat": 39.660006
    },
    {
      "lng": -76.173913,
      "lat": 39.660161
    },
    {
      "lng": -76.212676,
      "lat": 39.686405
    },
    {
      "lng": -76.233259,
      "lat": 39.721305
    },
    {
      "lng": -76.224191,
      "lat": 39.721328
    },
    {
      "lng": -76.135584,
      "lat": 39.721556
    }
  ],
  "Prince George's County MD": [
    {
      "lng": -77.042045,
      "lat": 38.720202
    },
    {
      "lng": -77.041398,
      "lat": 38.724515
    },
    {
      "lng": -77.040998,
      "lat": 38.737914
    },
    {
      "lng": -77.041898,
      "lat": 38.741514
    },
    {
      "lng": -77.041098,
      "lat": 38.773313
    },
    {
      "lng": -77.040373,
      "lat": 38.785355
    },
    {
      "lng": -77.040098,
      "lat": 38.789913
    },
    {
      "lng": -77.039498,
      "lat": 38.791113
    },
    {
      "lng": -77.038598,
      "lat": 38.791513
    },
    {
      "lng": -77.024392,
      "lat": 38.80297
    },
    {
      "lng": -77.001397,
      "lat": 38.821513
    },
    {
      "lng": -76.999997,
      "lat": 38.821913
    },
    {
      "lng": -76.992697,
      "lat": 38.828213
    },
    {
      "lng": -76.979497,
      "lat": 38.837812
    },
    {
      "lng": -76.953696,
      "lat": 38.858512
    },
    {
      "lng": -76.949696,
      "lat": 38.861312
    },
    {
      "lng": -76.920195,
      "lat": 38.884412
    },
    {
      "lng": -76.919295,
      "lat": 38.885112
    },
    {
      "lng": -76.910795,
      "lat": 38.891712
    },
    {
      "lng": -76.909395,
      "lat": 38.892812
    },
    {
      "lng": -76.935096,
      "lat": 38.913311
    },
    {
      "lng": -76.941519,
      "lat": 38.918276
    },
    {
      "lng": -77.002498,
      "lat": 38.96541
    },
    {
      "lng": -77.002636,
      "lat": 38.965521
    },
    {
      "lng": -76.991071,
      "lat": 38.992349
    },
    {
      "lng": -76.989059,
      "lat": 38.995577
    },
    {
      "lng": -76.988265,
      "lat": 38.996288
    },
    {
      "lng": -76.985693,
      "lat": 38.99998
    },
    {
      "lng": -76.98415,
      "lat": 39.001438
    },
    {
      "lng": -76.979606,
      "lat": 39.008161
    },
    {
      "lng": -76.977278,
      "lat": 39.010947
    },
    {
      "lng": -76.974565,
      "lat": 39.014714
    },
    {
      "lng": -76.973771,
      "lat": 39.015718
    },
    {
      "lng": -76.972097,
      "lat": 39.018109
    },
    {
      "lng": -76.9711,
      "lat": 39.019305
    },
    {
      "lng": -76.969748,
      "lat": 39.021343
    },
    {
      "lng": -76.888505,
      "lat": 39.130967
    },
    {
      "lng": -76.869003,
      "lat": 39.112214
    },
    {
      "lng": -76.840362,
      "lat": 39.103142
    },
    {
      "lng": -76.833488,
      "lat": 39.09589
    },
    {
      "lng": -76.827402,
      "lat": 39.091341
    },
    {
      "lng": -76.831508,
      "lat": 39.086554
    },
    {
      "lng": -76.832589,
      "lat": 39.076816
    },
    {
      "lng": -76.837327,
      "lat": 39.070917
    },
    {
      "lng": -76.832508,
      "lat": 39.069245
    },
    {
      "lng": -76.826197,
      "lat": 39.065297
    },
    {
      "lng": -76.819421,
      "lat": 39.062438
    },
    {
      "lng": -76.81189,
      "lat": 39.061275
    },
    {
      "lng": -76.801973,
      "lat": 39.058841
    },
    {
      "lng": -76.794518,
      "lat": 39.052828
    },
    {
      "lng": -76.793371,
      "lat": 39.04853
    },
    {
      "lng": -76.788748,
      "lat": 39.045025
    },
    {
      "lng": -76.776781,
      "lat": 39.044974
    },
    {
      "lng": -76.772301,
      "lat": 39.040819
    },
    {
      "lng": -76.766631,
      "lat": 39.039628
    },
    {
      "lng": -76.761313,
      "lat": 39.035379
    },
    {
      "lng": -76.755314,
      "lat": 39.037176
    },
    {
      "lng": -76.75131,
      "lat": 39.034718
    },
    {
      "lng": -76.749131,
      "lat": 39.02951
    },
    {
      "lng": -76.743291,
      "lat": 39.016714
    },
    {
      "lng": -76.737913,
      "lat": 39.01248
    },
    {
      "lng": -76.731993,
      "lat": 39.007051
    },
    {
      "lng": -76.724628,
      "lat": 38.999022
    },
    {
      "lng": -76.715854,
      "lat": 38.997114
    },
    {
      "lng": -76.708695,
      "lat": 38.99199
    },
    {
      "lng": -76.702394,
      "lat": 38.986971
    },
    {
      "lng": -76.700957,
      "lat": 38.980324
    },
    {
      "lng": -76.702762,
      "lat": 38.973313
    },
    {
      "lng": -76.698932,
      "lat": 38.965327
    },
    {
      "lng": -76.693928,
      "lat": 38.955589
    },
    {
      "lng": -76.693286,
      "lat": 38.951416
    },
    {
      "lng": -76.690533,
      "lat": 38.924763
    },
    {
      "lng": -76.670111,
      "lat": 38.906919
    },
    {
      "lng": -76.676575,
      "lat": 38.875964
    },
    {
      "lng": -76.683162,
      "lat": 38.866721
    },
    {
      "lng": -76.691527,
      "lat": 38.8598
    },
    {
      "lng": -76.691869,
      "lat": 38.859212
    },
    {
      "lng": -76.69213,
      "lat": 38.858367
    },
    {
      "lng": -76.692212,
      "lat": 38.857641
    },
    {
      "lng": -76.692124,
      "lat": 38.857131
    },
    {
      "lng": -76.691417,
      "lat": 38.856218
    },
    {
      "lng": -76.691033,
      "lat": 38.855508
    },
    {
      "lng": -76.690963,
      "lat": 38.854982
    },
    {
      "lng": -76.691051,
      "lat": 38.854695
    },
    {
      "lng": -76.692353,
      "lat": 38.851499
    },
    {
      "lng": -76.693647,
      "lat": 38.849716
    },
    {
      "lng": -76.696549,
      "lat": 38.847164
    },
    {
      "lng": -76.69755,
      "lat": 38.844647
    },
    {
      "lng": -76.698273,
      "lat": 38.84303
    },
    {
      "lng": -76.698458,
      "lat": 38.841392
    },
    {
      "lng": -76.699095,
      "lat": 38.839909
    },
    {
      "lng": -76.699569,
      "lat": 38.838274
    },
    {
      "lng": -76.699717,
      "lat": 38.836778
    },
    {
      "lng": -76.699361,
      "lat": 38.835638
    },
    {
      "lng": -76.69896,
      "lat": 38.834558
    },
    {
      "lng": -76.699011,
      "lat": 38.834101
    },
    {
      "lng": -76.69936,
      "lat": 38.832779
    },
    {
      "lng": -76.699174,
      "lat": 38.831713
    },
    {
      "lng": -76.698979,
      "lat": 38.831151
    },
    {
      "lng": -76.698169,
      "lat": 38.829871
    },
    {
      "lng": -76.697807,
      "lat": 38.828779
    },
    {
      "lng": -76.69754,
      "lat": 38.826154
    },
    {
      "lng": -76.697522,
      "lat": 38.825694
    },
    {
      "lng": -76.696371,
      "lat": 38.822724
    },
    {
      "lng": -76.696882,
      "lat": 38.820608
    },
    {
      "lng": -76.696863,
      "lat": 38.819806
    },
    {
      "lng": -76.696965,
      "lat": 38.818784
    },
    {
      "lng": -76.697826,
      "lat": 38.817948
    },
    {
      "lng": -76.700902,
      "lat": 38.81596
    },
    {
      "lng": -76.701775,
      "lat": 38.815538
    },
    {
      "lng": -76.702609,
      "lat": 38.815318
    },
    {
      "lng": -76.703839,
      "lat": 38.815133
    },
    {
      "lng": -76.705024,
      "lat": 38.815229
    },
    {
      "lng": -76.70687,
      "lat": 38.815732
    },
    {
      "lng": -76.707746,
      "lat": 38.816135
    },
    {
      "lng": -76.708117,
      "lat": 38.816423
    },
    {
      "lng": -76.709424,
      "lat": 38.816264
    },
    {
      "lng": -76.710639,
      "lat": 38.815694
    },
    {
      "lng": -76.712067,
      "lat": 38.814002
    },
    {
      "lng": -76.712347,
      "lat": 38.811684
    },
    {
      "lng": -76.711975,
      "lat": 38.810153
    },
    {
      "lng": -76.710874,
      "lat": 38.808289
    },
    {
      "lng": -76.708907,
      "lat": 38.806474
    },
    {
      "lng": -76.708065,
      "lat": 38.804867
    },
    {
      "lng": -76.708403,
      "lat": 38.803114
    },
    {
      "lng": -76.709802,
      "lat": 38.800554
    },
    {
      "lng": -76.710676,
      "lat": 38.79843
    },
    {
      "lng": -76.710705,
      "lat": 38.797645
    },
    {
      "lng": -76.710116,
      "lat": 38.796003
    },
    {
      "lng": -76.70942,
      "lat": 38.795131
    },
    {
      "lng": -76.706588,
      "lat": 38.792707
    },
    {
      "lng": -76.704578,
      "lat": 38.791437
    },
    {
      "lng": -76.70254,
      "lat": 38.790397
    },
    {
      "lng": -76.702055,
      "lat": 38.789729
    },
    {
      "lng": -76.702025,
      "lat": 38.788747
    },
    {
      "lng": -76.702403,
      "lat": 38.787945
    },
    {
      "lng": -76.712548,
      "lat": 38.77491
    },
    {
      "lng": -76.700947,
      "lat": 38.768747
    },
    {
      "lng": -76.6995,
      "lat": 38.754121
    },
    {
      "lng": -76.686358,
      "lat": 38.748475
    },
    {
      "lng": -76.684866,
      "lat": 38.746927
    },
    {
      "lng": -76.684839,
      "lat": 38.743757
    },
    {
      "lng": -76.684018,
      "lat": 38.738348
    },
    {
      "lng": -76.684844,
      "lat": 38.736749
    },
    {
      "lng": -76.687009,
      "lat": 38.735897
    },
    {
      "lng": -76.693841,
      "lat": 38.735911
    },
    {
      "lng": -76.694996,
      "lat": 38.735075
    },
    {
      "lng": -76.693589,
      "lat": 38.724761
    },
    {
      "lng": -76.70196,
      "lat": 38.710864
    },
    {
      "lng": -76.694946,
      "lat": 38.702468
    },
    {
      "lng": -76.698429,
      "lat": 38.690443
    },
    {
      "lng": -76.687147,
      "lat": 38.681371
    },
    {
      "lng": -76.687424,
      "lat": 38.678746
    },
    {
      "lng": -76.690461,
      "lat": 38.673683
    },
    {
      "lng": -76.692956,
      "lat": 38.672353
    },
    {
      "lng": -76.699261,
      "lat": 38.671109
    },
    {
      "lng": -76.701003,
      "lat": 38.668362
    },
    {
      "lng": -76.699261,
      "lat": 38.665769
    },
    {
      "lng": -76.683329,
      "lat": 38.661178
    },
    {
      "lng": -76.685127,
      "lat": 38.654771
    },
    {
      "lng": -76.69163,
      "lat": 38.648506
    },
    {
      "lng": -76.692853,
      "lat": 38.636437
    },
    {
      "lng": -76.686138,
      "lat": 38.630182
    },
    {
      "lng": -76.679355,
      "lat": 38.627949
    },
    {
      "lng": -76.672334,
      "lat": 38.617533
    },
    {
      "lng": -76.672557,
      "lat": 38.599271
    },
    {
      "lng": -76.680702,
      "lat": 38.580499
    },
    {
      "lng": -76.672274,
      "lat": 38.552846
    },
    {
      "lng": -76.675457,
      "lat": 38.535876
    },
    {
      "lng": -76.678298,
      "lat": 38.535372
    },
    {
      "lng": -76.681621,
      "lat": 38.536017
    },
    {
      "lng": -76.684885,
      "lat": 38.536809
    },
    {
      "lng": -76.686344,
      "lat": 38.537411
    },
    {
      "lng": -76.688211,
      "lat": 38.537664
    },
    {
      "lng": -76.689818,
      "lat": 38.537628
    },
    {
      "lng": -76.690784,
      "lat": 38.537944
    },
    {
      "lng": -76.691476,
      "lat": 38.538447
    },
    {
      "lng": -76.692039,
      "lat": 38.5405
    },
    {
      "lng": -76.692537,
      "lat": 38.541165
    },
    {
      "lng": -76.697064,
      "lat": 38.543165
    },
    {
      "lng": -76.697761,
      "lat": 38.543281
    },
    {
      "lng": -76.699586,
      "lat": 38.542485
    },
    {
      "lng": -76.701162,
      "lat": 38.542474
    },
    {
      "lng": -76.701145,
      "lat": 38.544676
    },
    {
      "lng": -76.702016,
      "lat": 38.545541
    },
    {
      "lng": -76.737508,
      "lat": 38.557098
    },
    {
      "lng": -76.747335,
      "lat": 38.616677
    },
    {
      "lng": -76.862955,
      "lat": 38.658649
    },
    {
      "lng": -76.904705,
      "lat": 38.651561
    },
    {
      "lng": -76.939555,
      "lat": 38.654589
    },
    {
      "lng": -76.965748,
      "lat": 38.66127
    },
    {
      "lng": -77.011028,
      "lat": 38.651975
    },
    {
      "lng": -77.047656,
      "lat": 38.616303
    },
    {
      "lng": -77.077027,
      "lat": 38.690168
    },
    {
      "lng": -77.078599,
      "lat": 38.694114
    },
    {
      "lng": -77.086329,
      "lat": 38.706128
    },
    {
      "lng": -77.079499,
      "lat": 38.709515
    },
    {
      "lng": -77.072807,
      "lat": 38.711526
    },
    {
      "lng": -77.071861,
      "lat": 38.710581
    },
    {
      "lng": -77.065322,
      "lat": 38.709564
    },
    {
      "lng": -77.053199,
      "lat": 38.709915
    },
    {
      "lng": -77.045498,
      "lat": 38.714315
    },
    {
      "lng": -77.042298,
      "lat": 38.718515
    },
    {
      "lng": -77.042045,
      "lat": 38.720202
    }
  ],
  "Essex County MA": [
    {
      "lng": -71.245504,
      "lat": 42.742589
    },
    {
      "lng": -71.233404,
      "lat": 42.745489
    },
    {
      "lng": -71.223904,
      "lat": 42.746689
    },
    {
      "lng": -71.208302,
      "lat": 42.743314
    },
    {
      "lng": -71.208227,
      "lat": 42.743294
    },
    {
      "lng": -71.208137,
      "lat": 42.743273
    },
    {
      "lng": -71.181803,
      "lat": 42.73759
    },
    {
      "lng": -71.186104,
      "lat": 42.790689
    },
    {
      "lng": -71.174403,
      "lat": 42.801589
    },
    {
      "lng": -71.167703,
      "lat": 42.807389
    },
    {
      "lng": -71.165603,
      "lat": 42.808689
    },
    {
      "lng": -71.149703,
      "lat": 42.815489
    },
    {
      "lng": -71.132503,
      "lat": 42.821389
    },
    {
      "lng": -71.116048,
      "lat": 42.817751
    },
    {
      "lng": -71.064201,
      "lat": 42.806289
    },
    {
      "lng": -71.053601,
      "lat": 42.833089
    },
    {
      "lng": -71.047501,
      "lat": 42.844089
    },
    {
      "lng": -71.044401,
      "lat": 42.848789
    },
    {
      "lng": -71.031201,
      "lat": 42.859089
    },
    {
      "lng": -70.9665,
      "lat": 42.868989
    },
    {
      "lng": -70.949199,
      "lat": 42.876089
    },
    {
      "lng": -70.931699,
      "lat": 42.884189
    },
    {
      "lng": -70.930799,
      "lat": 42.884589
    },
    {
      "lng": -70.927629,
      "lat": 42.885326
    },
    {
      "lng": -70.914899,
      "lat": 42.886589
    },
    {
      "lng": -70.914886,
      "lat": 42.886564
    },
    {
      "lng": -70.902768,
      "lat": 42.88653
    },
    {
      "lng": -70.886136,
      "lat": 42.88261
    },
    {
      "lng": -70.848625,
      "lat": 42.860939
    },
    {
      "lng": -70.837376,
      "lat": 42.864996
    },
    {
      "lng": -70.830795,
      "lat": 42.868918
    },
    {
      "lng": -70.821769,
      "lat": 42.87188
    },
    {
      "lng": -70.817296,
      "lat": 42.87229
    },
    {
      "lng": -70.817731,
      "lat": 42.850613
    },
    {
      "lng": -70.80522,
      "lat": 42.781798
    },
    {
      "lng": -70.792867,
      "lat": 42.747118
    },
    {
      "lng": -70.772267,
      "lat": 42.711064
    },
    {
      "lng": -70.770453,
      "lat": 42.704824
    },
    {
      "lng": -70.778552,
      "lat": 42.69852
    },
    {
      "lng": -70.778671,
      "lat": 42.693622
    },
    {
      "lng": -70.764421,
      "lat": 42.68565
    },
    {
      "lng": -70.748752,
      "lat": 42.683878
    },
    {
      "lng": -70.744427,
      "lat": 42.682092
    },
    {
      "lng": -70.72982,
      "lat": 42.669602
    },
    {
      "lng": -70.728845,
      "lat": 42.663877
    },
    {
      "lng": -70.689402,
      "lat": 42.653319
    },
    {
      "lng": -70.682594,
      "lat": 42.654525
    },
    {
      "lng": -70.681594,
      "lat": 42.662342
    },
    {
      "lng": -70.663548,
      "lat": 42.677603
    },
    {
      "lng": -70.645101,
      "lat": 42.689423
    },
    {
      "lng": -70.630077,
      "lat": 42.692699
    },
    {
      "lng": -70.620031,
      "lat": 42.688006
    },
    {
      "lng": -70.622864,
      "lat": 42.67599
    },
    {
      "lng": -70.623815,
      "lat": 42.665481
    },
    {
      "lng": -70.622791,
      "lat": 42.660873
    },
    {
      "lng": -70.61482,
      "lat": 42.65765
    },
    {
      "lng": -70.595474,
      "lat": 42.660336
    },
    {
      "lng": -70.591742,
      "lat": 42.648508
    },
    {
      "lng": -70.591469,
      "lat": 42.639821
    },
    {
      "lng": -70.594014,
      "lat": 42.63503
    },
    {
      "lng": -70.605611,
      "lat": 42.634898
    },
    {
      "lng": -70.61842,
      "lat": 42.62864
    },
    {
      "lng": -70.635635,
      "lat": 42.600243
    },
    {
      "lng": -70.654727,
      "lat": 42.582234
    },
    {
      "lng": -70.664887,
      "lat": 42.580436
    },
    {
      "lng": -70.668022,
      "lat": 42.581732
    },
    {
      "lng": -70.668115,
      "lat": 42.585361
    },
    {
      "lng": -70.668488,
      "lat": 42.589643
    },
    {
      "lng": -70.670442,
      "lat": 42.592249
    },
    {
      "lng": -70.672583,
      "lat": 42.594296
    },
    {
      "lng": -70.675747,
      "lat": 42.594669
    },
    {
      "lng": -70.678819,
      "lat": 42.594389
    },
    {
      "lng": -70.681428,
      "lat": 42.593173
    },
    {
      "lng": -70.684502,
      "lat": 42.588858
    },
    {
      "lng": -70.698574,
      "lat": 42.577393
    },
    {
      "lng": -70.729688,
      "lat": 42.57151
    },
    {
      "lng": -70.737044,
      "lat": 42.576863
    },
    {
      "lng": -70.757283,
      "lat": 42.570455
    },
    {
      "lng": -70.804091,
      "lat": 42.561595
    },
    {
      "lng": -70.815391,
      "lat": 42.554195
    },
    {
      "lng": -70.823291,
      "lat": 42.551495
    },
    {
      "lng": -70.848492,
      "lat": 42.550195
    },
    {
      "lng": -70.871382,
      "lat": 42.546404
    },
    {
      "lng": -70.872357,
      "lat": 42.542952
    },
    {
      "lng": -70.866279,
      "lat": 42.522617
    },
    {
      "lng": -70.859751,
      "lat": 42.520441
    },
    {
      "lng": -70.857125,
      "lat": 42.521492
    },
    {
      "lng": -70.842091,
      "lat": 42.519495
    },
    {
      "lng": -70.831091,
      "lat": 42.503596
    },
    {
      "lng": -70.835991,
      "lat": 42.490496
    },
    {
      "lng": -70.841591,
      "lat": 42.487596
    },
    {
      "lng": -70.847391,
      "lat": 42.491496
    },
    {
      "lng": -70.857791,
      "lat": 42.490296
    },
    {
      "lng": -70.879692,
      "lat": 42.478796
    },
    {
      "lng": -70.886493,
      "lat": 42.470197
    },
    {
      "lng": -70.887992,
      "lat": 42.467096
    },
    {
      "lng": -70.887292,
      "lat": 42.464896
    },
    {
      "lng": -70.894292,
      "lat": 42.460896
    },
    {
      "lng": -70.908092,
      "lat": 42.466896
    },
    {
      "lng": -70.917693,
      "lat": 42.467996
    },
    {
      "lng": -70.921993,
      "lat": 42.466696
    },
    {
      "lng": -70.934993,
      "lat": 42.457896
    },
    {
      "lng": -70.934264,
      "lat": 42.444646
    },
    {
      "lng": -70.933155,
      "lat": 42.437833
    },
    {
      "lng": -70.928226,
      "lat": 42.430986
    },
    {
      "lng": -70.913192,
      "lat": 42.427697
    },
    {
      "lng": -70.908392,
      "lat": 42.425197
    },
    {
      "lng": -70.901992,
      "lat": 42.420297
    },
    {
      "lng": -70.905692,
      "lat": 42.416197
    },
    {
      "lng": -70.936393,
      "lat": 42.418097
    },
    {
      "lng": -70.943295,
      "lat": 42.436248
    },
    {
      "lng": -70.943612,
      "lat": 42.452092
    },
    {
      "lng": -70.94702,
      "lat": 42.456236
    },
    {
      "lng": -70.96047,
      "lat": 42.446166
    },
    {
      "lng": -70.960647,
      "lat": 42.443787
    },
    {
      "lng": -70.982294,
      "lat": 42.431296
    },
    {
      "lng": -71.025777,
      "lat": 42.444753
    },
    {
      "lng": -71.053496,
      "lat": 42.475895
    },
    {
      "lng": -71.035296,
      "lat": 42.506995
    },
    {
      "lng": -71.040983,
      "lat": 42.526262
    },
    {
      "lng": -71.075257,
      "lat": 42.531122
    },
    {
      "lng": -71.070978,
      "lat": 42.555889
    },
    {
      "lng": -71.057164,
      "lat": 42.574151
    },
    {
      "lng": -71.028312,
      "lat": 42.574082
    },
    {
      "lng": -71.058772,
      "lat": 42.608996
    },
    {
      "lng": -71.076133,
      "lat": 42.604077
    },
    {
      "lng": -71.13529,
      "lat": 42.599061
    },
    {
      "lng": -71.158617,
      "lat": 42.612948
    },
    {
      "lng": -71.165015,
      "lat": 42.597959
    },
    {
      "lng": -71.172108,
      "lat": 42.616751
    },
    {
      "lng": -71.256103,
      "lat": 42.656691
    },
    {
      "lng": -71.238103,
      "lat": 42.669491
    },
    {
      "lng": -71.25518,
      "lat": 42.73665
    },
    {
      "lng": -71.245504,
      "lat": 42.742589
    }
  ],
  "Middlesex County MA": [
    {
      "lng": -71.898716,
      "lat": 42.71142
    },
    {
      "lng": -71.745817,
      "lat": 42.707287
    },
    {
      "lng": -71.636214,
      "lat": 42.704888
    },
    {
      "lng": -71.631814,
      "lat": 42.704788
    },
    {
      "lng": -71.542533,
      "lat": 42.702672
    },
    {
      "lng": -71.351874,
      "lat": 42.698154
    },
    {
      "lng": -71.330206,
      "lat": 42.69719
    },
    {
      "lng": -71.294205,
      "lat": 42.69699
    },
    {
      "lng": -71.278929,
      "lat": 42.711258
    },
    {
      "lng": -71.267905,
      "lat": 42.72589
    },
    {
      "lng": -71.255605,
      "lat": 42.736389
    },
    {
      "lng": -71.25518,
      "lat": 42.73665
    },
    {
      "lng": -71.238103,
      "lat": 42.669491
    },
    {
      "lng": -71.256103,
      "lat": 42.656691
    },
    {
      "lng": -71.172108,
      "lat": 42.616751
    },
    {
      "lng": -71.165015,
      "lat": 42.597959
    },
    {
      "lng": -71.158617,
      "lat": 42.612948
    },
    {
      "lng": -71.13529,
      "lat": 42.599061
    },
    {
      "lng": -71.076133,
      "lat": 42.604077
    },
    {
      "lng": -71.058772,
      "lat": 42.608996
    },
    {
      "lng": -71.028312,
      "lat": 42.574082
    },
    {
      "lng": -71.057164,
      "lat": 42.574151
    },
    {
      "lng": -71.070978,
      "lat": 42.555889
    },
    {
      "lng": -71.075257,
      "lat": 42.531122
    },
    {
      "lng": -71.040983,
      "lat": 42.526262
    },
    {
      "lng": -71.035296,
      "lat": 42.506995
    },
    {
      "lng": -71.053496,
      "lat": 42.475895
    },
    {
      "lng": -71.025777,
      "lat": 42.444753
    },
    {
      "lng": -71.020377,
      "lat": 42.43825
    },
    {
      "lng": -71.033203,
      "lat": 42.414226
    },
    {
      "lng": -71.055295,
      "lat": 42.387097
    },
    {
      "lng": -71.073496,
      "lat": 42.391796
    },
    {
      "lng": -71.080595,
      "lat": 42.380997
    },
    {
      "lng": -71.064095,
      "lat": 42.368997
    },
    {
      "lng": -71.069795,
      "lat": 42.369097
    },
    {
      "lng": -71.077095,
      "lat": 42.358697
    },
    {
      "lng": -71.099196,
      "lat": 42.352797
    },
    {
      "lng": -71.117099,
      "lat": 42.355594
    },
    {
      "lng": -71.117197,
      "lat": 42.367197
    },
    {
      "lng": -71.130997,
      "lat": 42.373796
    },
    {
      "lng": -71.143501,
      "lat": 42.364969
    },
    {
      "lng": -71.148565,
      "lat": 42.361174
    },
    {
      "lng": -71.167625,
      "lat": 42.360073
    },
    {
      "lng": -71.174798,
      "lat": 42.350265
    },
    {
      "lng": -71.156833,
      "lat": 42.330189
    },
    {
      "lng": -71.178935,
      "lat": 42.314316
    },
    {
      "lng": -71.164804,
      "lat": 42.303764
    },
    {
      "lng": -71.178636,
      "lat": 42.294595
    },
    {
      "lng": -71.191155,
      "lat": 42.283059
    },
    {
      "lng": -71.227689,
      "lat": 42.315473
    },
    {
      "lng": -71.23106,
      "lat": 42.320736
    },
    {
      "lng": -71.2475,
      "lat": 42.321486
    },
    {
      "lng": -71.269919,
      "lat": 42.328096
    },
    {
      "lng": -71.32975,
      "lat": 42.312991
    },
    {
      "lng": -71.302922,
      "lat": 42.248274
    },
    {
      "lng": -71.332434,
      "lat": 42.247729
    },
    {
      "lng": -71.338435,
      "lat": 42.215232
    },
    {
      "lng": -71.34417,
      "lat": 42.200703
    },
    {
      "lng": -71.384756,
      "lat": 42.192033
    },
    {
      "lng": -71.40222,
      "lat": 42.178798
    },
    {
      "lng": -71.444067,
      "lat": 42.174889
    },
    {
      "lng": -71.478119,
      "lat": 42.156782
    },
    {
      "lng": -71.497378,
      "lat": 42.166643
    },
    {
      "lng": -71.502626,
      "lat": 42.191416
    },
    {
      "lng": -71.58291,
      "lat": 42.195559
    },
    {
      "lng": -71.599318,
      "lat": 42.225959
    },
    {
      "lng": -71.586759,
      "lat": 42.259545
    },
    {
      "lng": -71.562194,
      "lat": 42.267651
    },
    {
      "lng": -71.513048,
      "lat": 42.267148
    },
    {
      "lng": -71.497046,
      "lat": 42.289829
    },
    {
      "lng": -71.486768,
      "lat": 42.330075
    },
    {
      "lng": -71.551126,
      "lat": 42.326395
    },
    {
      "lng": -71.585168,
      "lat": 42.310977
    },
    {
      "lng": -71.624702,
      "lat": 42.350465
    },
    {
      "lng": -71.610007,
      "lat": 42.357403
    },
    {
      "lng": -71.603187,
      "lat": 42.367329
    },
    {
      "lng": -71.580043,
      "lat": 42.386949
    },
    {
      "lng": -71.604251,
      "lat": 42.397703
    },
    {
      "lng": -71.559046,
      "lat": 42.411981
    },
    {
      "lng": -71.543297,
      "lat": 42.466451
    },
    {
      "lng": -71.560367,
      "lat": 42.47435
    },
    {
      "lng": -71.531476,
      "lat": 42.520487
    },
    {
      "lng": -71.538949,
      "lat": 42.543069
    },
    {
      "lng": -71.580287,
      "lat": 42.550467
    },
    {
      "lng": -71.594643,
      "lat": 42.54337
    },
    {
      "lng": -71.620039,
      "lat": 42.55245
    },
    {
      "lng": -71.636079,
      "lat": 42.539924
    },
    {
      "lng": -71.635812,
      "lat": 42.524091
    },
    {
      "lng": -71.67898,
      "lat": 42.530351
    },
    {
      "lng": -71.67773,
      "lat": 42.539397
    },
    {
      "lng": -71.664614,
      "lat": 42.611589
    },
    {
      "lng": -71.775742,
      "lat": 42.644216
    },
    {
      "lng": -71.775322,
      "lat": 42.636663
    },
    {
      "lng": -71.844843,
      "lat": 42.637985
    },
    {
      "lng": -71.85841,
      "lat": 42.63384
    },
    {
      "lng": -71.85782,
      "lat": 42.674987
    },
    {
      "lng": -71.897089,
      "lat": 42.703826
    },
    {
      "lng": -71.898716,
      "lat": 42.71142
    }
  ],
  "Norfolk County MA": [
    {
      "lng": -71.381466,
      "lat": 41.984998
    },
    {
      "lng": -71.381401,
      "lat": 42.018798
    },
    {
      "lng": -71.458104,
      "lat": 42.017762
    },
    {
      "lng": -71.498258,
      "lat": 42.01722
    },
    {
      "lng": -71.50091,
      "lat": 42.117041
    },
    {
      "lng": -71.478521,
      "lat": 42.131421
    },
    {
      "lng": -71.478119,
      "lat": 42.156782
    },
    {
      "lng": -71.444067,
      "lat": 42.174889
    },
    {
      "lng": -71.40222,
      "lat": 42.178798
    },
    {
      "lng": -71.384756,
      "lat": 42.192033
    },
    {
      "lng": -71.34417,
      "lat": 42.200703
    },
    {
      "lng": -71.338435,
      "lat": 42.215232
    },
    {
      "lng": -71.332434,
      "lat": 42.247729
    },
    {
      "lng": -71.302922,
      "lat": 42.248274
    },
    {
      "lng": -71.32975,
      "lat": 42.312991
    },
    {
      "lng": -71.269919,
      "lat": 42.328096
    },
    {
      "lng": -71.2475,
      "lat": 42.321486
    },
    {
      "lng": -71.23106,
      "lat": 42.320736
    },
    {
      "lng": -71.227689,
      "lat": 42.315473
    },
    {
      "lng": -71.191155,
      "lat": 42.283059
    },
    {
      "lng": -71.130808,
      "lat": 42.22788
    },
    {
      "lng": -71.112938,
      "lat": 42.258641
    },
    {
      "lng": -71.074894,
      "lat": 42.270303
    },
    {
      "lng": -71.042794,
      "lat": 42.276998
    },
    {
      "lng": -71.041594,
      "lat": 42.278098
    },
    {
      "lng": -71.040494,
      "lat": 42.281898
    },
    {
      "lng": -71.03908,
      "lat": 42.283966
    },
    {
      "lng": -71.035294,
      "lat": 42.288798
    },
    {
      "lng": -71.041694,
      "lat": 42.305298
    },
    {
      "lng": -71.005399,
      "lat": 42.307196
    },
    {
      "lng": -71.000948,
      "lat": 42.302483
    },
    {
      "lng": -71.006158,
      "lat": 42.28811
    },
    {
      "lng": -71.0049,
      "lat": 42.28272
    },
    {
      "lng": -70.996097,
      "lat": 42.271222
    },
    {
      "lng": -70.98909,
      "lat": 42.267449
    },
    {
      "lng": -70.967351,
      "lat": 42.268168
    },
    {
      "lng": -70.948971,
      "lat": 42.272505
    },
    {
      "lng": -70.945547,
      "lat": 42.269081
    },
    {
      "lng": -70.935886,
      "lat": 42.264189
    },
    {
      "lng": -70.923169,
      "lat": 42.263211
    },
    {
      "lng": -70.910941,
      "lat": 42.265412
    },
    {
      "lng": -70.906302,
      "lat": 42.271636
    },
    {
      "lng": -70.917081,
      "lat": 42.2556
    },
    {
      "lng": -70.932435,
      "lat": 42.252644
    },
    {
      "lng": -70.91485,
      "lat": 42.224408
    },
    {
      "lng": -70.924877,
      "lat": 42.15758
    },
    {
      "lng": -70.981293,
      "lat": 42.135502
    },
    {
      "lng": -70.993114,
      "lat": 42.130855
    },
    {
      "lng": -71.002029,
      "lat": 42.126506
    },
    {
      "lng": -71.080192,
      "lat": 42.095699
    },
    {
      "lng": -71.138619,
      "lat": 42.072813
    },
    {
      "lng": -71.168681,
      "lat": 42.061161
    },
    {
      "lng": -71.288265,
      "lat": 42.014462
    },
    {
      "lng": -71.288265,
      "lat": 42.014451
    },
    {
      "lng": -71.288263,
      "lat": 42.014379
    },
    {
      "lng": -71.364887,
      "lat": 41.985173
    },
    {
      "lng": -71.381466,
      "lat": 41.984998
    }
  ],
  "Plymouth County MA": [
    {
      "lng": -70.981293,
      "lat": 42.135502
    },
    {
      "lng": -70.924877,
      "lat": 42.15758
    },
    {
      "lng": -70.91485,
      "lat": 42.224408
    },
    {
      "lng": -70.932435,
      "lat": 42.252644
    },
    {
      "lng": -70.917081,
      "lat": 42.2556
    },
    {
      "lng": -70.906302,
      "lat": 42.271636
    },
    {
      "lng": -70.896267,
      "lat": 42.2851
    },
    {
      "lng": -70.895778,
      "lat": 42.292436
    },
    {
      "lng": -70.897123,
      "lat": 42.29586
    },
    {
      "lng": -70.915588,
      "lat": 42.302463
    },
    {
      "lng": -70.91749,
      "lat": 42.305686
    },
    {
      "lng": -70.907556,
      "lat": 42.307889
    },
    {
      "lng": -70.882764,
      "lat": 42.30886
    },
    {
      "lng": -70.881242,
      "lat": 42.300663
    },
    {
      "lng": -70.870873,
      "lat": 42.285668
    },
    {
      "lng": -70.861807,
      "lat": 42.275965
    },
    {
      "lng": -70.851093,
      "lat": 42.26827
    },
    {
      "lng": -70.831075,
      "lat": 42.267424
    },
    {
      "lng": -70.824661,
      "lat": 42.265935
    },
    {
      "lng": -70.844614,
      "lat": 42.260512
    },
    {
      "lng": -70.85338,
      "lat": 42.239607
    },
    {
      "lng": -70.826933,
      "lat": 42.200678
    },
    {
      "lng": -70.785081,
      "lat": 42.225276
    },
    {
      "lng": -70.780722,
      "lat": 42.251792
    },
    {
      "lng": -70.770964,
      "lat": 42.249197
    },
    {
      "lng": -70.764757,
      "lat": 42.244062
    },
    {
      "lng": -70.754488,
      "lat": 42.228673
    },
    {
      "lng": -70.74723,
      "lat": 42.221816
    },
    {
      "lng": -70.73056,
      "lat": 42.21094
    },
    {
      "lng": -70.722269,
      "lat": 42.207959
    },
    {
      "lng": -70.718707,
      "lat": 42.184853
    },
    {
      "lng": -70.714301,
      "lat": 42.168783
    },
    {
      "lng": -70.706264,
      "lat": 42.163137
    },
    {
      "lng": -70.685315,
      "lat": 42.133025
    },
    {
      "lng": -70.663931,
      "lat": 42.108336
    },
    {
      "lng": -70.640169,
      "lat": 42.088633
    },
    {
      "lng": -70.63848,
      "lat": 42.081579
    },
    {
      "lng": -70.647349,
      "lat": 42.076331
    },
    {
      "lng": -70.64819,
      "lat": 42.068441
    },
    {
      "lng": -70.643208,
      "lat": 42.050821
    },
    {
      "lng": -70.644337,
      "lat": 42.045895
    },
    {
      "lng": -70.650874,
      "lat": 42.046247
    },
    {
      "lng": -70.66936,
      "lat": 42.037116
    },
    {
      "lng": -70.671666,
      "lat": 42.02139
    },
    {
      "lng": -70.667512,
      "lat": 42.01232
    },
    {
      "lng": -70.670934,
      "lat": 42.007786
    },
    {
      "lng": -70.678798,
      "lat": 42.00551
    },
    {
      "lng": -70.686798,
      "lat": 42.012764
    },
    {
      "lng": -70.695809,
      "lat": 42.013346
    },
    {
      "lng": -70.712204,
      "lat": 42.007586
    },
    {
      "lng": -70.710034,
      "lat": 41.999544
    },
    {
      "lng": -70.698981,
      "lat": 41.987103
    },
    {
      "lng": -70.662476,
      "lat": 41.960592
    },
    {
      "lng": -70.651673,
      "lat": 41.958701
    },
    {
      "lng": -70.648365,
      "lat": 41.961672
    },
    {
      "lng": -70.631251,
      "lat": 41.950475
    },
    {
      "lng": -70.623513,
      "lat": 41.943273
    },
    {
      "lng": -70.616491,
      "lat": 41.940204
    },
    {
      "lng": -70.608166,
      "lat": 41.940701
    },
    {
      "lng": -70.598078,
      "lat": 41.947772
    },
    {
      "lng": -70.583572,
      "lat": 41.950007
    },
    {
      "lng": -70.552941,
      "lat": 41.929641
    },
    {
      "lng": -70.546386,
      "lat": 41.916751
    },
    {
      "lng": -70.54741,
      "lat": 41.911934
    },
    {
      "lng": -70.545949,
      "lat": 41.907158
    },
    {
      "lng": -70.532084,
      "lat": 41.889568
    },
    {
      "lng": -70.525567,
      "lat": 41.85873
    },
    {
      "lng": -70.535487,
      "lat": 41.839381
    },
    {
      "lng": -70.542065,
      "lat": 41.831263
    },
    {
      "lng": -70.543168,
      "lat": 41.824446
    },
    {
      "lng": -70.54103,
      "lat": 41.815754
    },
    {
      "lng": -70.537289,
      "lat": 41.810859
    },
    {
      "lng": -70.565281,
      "lat": 41.786705
    },
    {
      "lng": -70.632578,
      "lat": 41.762821
    },
    {
      "lng": -70.621622,
      "lat": 41.748972
    },
    {
      "lng": -70.642914,
      "lat": 41.71841
    },
    {
      "lng": -70.644641,
      "lat": 41.71898
    },
    {
      "lng": -70.651093,
      "lat": 41.715715
    },
    {
      "lng": -70.656596,
      "lat": 41.715401
    },
    {
      "lng": -70.670453,
      "lat": 41.721912
    },
    {
      "lng": -70.708193,
      "lat": 41.730959
    },
    {
      "lng": -70.718739,
      "lat": 41.73574
    },
    {
      "lng": -70.726331,
      "lat": 41.732731
    },
    {
      "lng": -70.728933,
      "lat": 41.723433
    },
    {
      "lng": -70.721302,
      "lat": 41.712968
    },
    {
      "lng": -70.717451,
      "lat": 41.69398
    },
    {
      "lng": -70.719575,
      "lat": 41.685002
    },
    {
      "lng": -70.729395,
      "lat": 41.68814
    },
    {
      "lng": -70.744396,
      "lat": 41.696967
    },
    {
      "lng": -70.755347,
      "lat": 41.694326
    },
    {
      "lng": -70.761481,
      "lat": 41.676808
    },
    {
      "lng": -70.76236,
      "lat": 41.667735
    },
    {
      "lng": -70.758198,
      "lat": 41.661225
    },
    {
      "lng": -70.757622,
      "lat": 41.654265
    },
    {
      "lng": -70.765463,
      "lat": 41.641575
    },
    {
      "lng": -70.769318,
      "lat": 41.641145
    },
    {
      "lng": -70.773654,
      "lat": 41.645033
    },
    {
      "lng": -70.775798,
      "lat": 41.649145
    },
    {
      "lng": -70.776709,
      "lat": 41.650756
    },
    {
      "lng": -70.809118,
      "lat": 41.656437
    },
    {
      "lng": -70.813286,
      "lat": 41.65567
    },
    {
      "lng": -70.815729,
      "lat": 41.652796
    },
    {
      "lng": -70.816351,
      "lat": 41.645995
    },
    {
      "lng": -70.804664,
      "lat": 41.641157
    },
    {
      "lng": -70.800215,
      "lat": 41.631753
    },
    {
      "lng": -70.801063,
      "lat": 41.629513
    },
    {
      "lng": -70.810279,
      "lat": 41.624873
    },
    {
      "lng": -70.835296,
      "lat": 41.624532
    },
    {
      "lng": -70.843177,
      "lat": 41.628487
    },
    {
      "lng": -70.845242,
      "lat": 41.644665
    },
    {
      "lng": -70.886439,
      "lat": 41.760232
    },
    {
      "lng": -70.904438,
      "lat": 41.758
    },
    {
      "lng": -70.921782,
      "lat": 41.791244
    },
    {
      "lng": -71.026288,
      "lat": 41.778888
    },
    {
      "lng": -71.014494,
      "lat": 41.799382
    },
    {
      "lng": -71.03657,
      "lat": 41.816525
    },
    {
      "lng": -70.973717,
      "lat": 41.860879
    },
    {
      "lng": -70.999705,
      "lat": 41.929592
    },
    {
      "lng": -71.049498,
      "lat": 41.96315
    },
    {
      "lng": -71.054718,
      "lat": 41.985057
    },
    {
      "lng": -71.080192,
      "lat": 42.095699
    },
    {
      "lng": -71.002029,
      "lat": 42.126506
    },
    {
      "lng": -70.993114,
      "lat": 42.130855
    },
    {
      "lng": -70.981293,
      "lat": 42.135502
    }
  ],
  "Suffolk County MA": [
    {
      "lng": -71.042794,
      "lat": 42.276998
    },
    {
      "lng": -71.074894,
      "lat": 42.270303
    },
    {
      "lng": -71.112938,
      "lat": 42.258641
    },
    {
      "lng": -71.130808,
      "lat": 42.22788
    },
    {
      "lng": -71.191155,
      "lat": 42.283059
    },
    {
      "lng": -71.178636,
      "lat": 42.294595
    },
    {
      "lng": -71.164804,
      "lat": 42.303764
    },
    {
      "lng": -71.152195,
      "lat": 42.294597
    },
    {
      "lng": -71.126999,
      "lat": 42.318615
    },
    {
      "lng": -71.116608,
      "lat": 42.32395
    },
    {
      "lng": -71.10657,
      "lat": 42.349912
    },
    {
      "lng": -71.122423,
      "lat": 42.351811
    },
    {
      "lng": -71.156833,
      "lat": 42.330189
    },
    {
      "lng": -71.174798,
      "lat": 42.350265
    },
    {
      "lng": -71.167625,
      "lat": 42.360073
    },
    {
      "lng": -71.148565,
      "lat": 42.361174
    },
    {
      "lng": -71.143501,
      "lat": 42.364969
    },
    {
      "lng": -71.130997,
      "lat": 42.373796
    },
    {
      "lng": -71.117197,
      "lat": 42.367197
    },
    {
      "lng": -71.117099,
      "lat": 42.355594
    },
    {
      "lng": -71.099196,
      "lat": 42.352797
    },
    {
      "lng": -71.077095,
      "lat": 42.358697
    },
    {
      "lng": -71.069795,
      "lat": 42.369097
    },
    {
      "lng": -71.064095,
      "lat": 42.368997
    },
    {
      "lng": -71.080595,
      "lat": 42.380997
    },
    {
      "lng": -71.073496,
      "lat": 42.391796
    },
    {
      "lng": -71.055295,
      "lat": 42.387097
    },
    {
      "lng": -71.033203,
      "lat": 42.414226
    },
    {
      "lng": -71.020377,
      "lat": 42.43825
    },
    {
      "lng": -71.025777,
      "lat": 42.444753
    },
    {
      "lng": -70.982294,
      "lat": 42.431296
    },
    {
      "lng": -70.960647,
      "lat": 42.443787
    },
    {
      "lng": -70.960835,
      "lat": 42.441272
    },
    {
      "lng": -70.982994,
      "lat": 42.423996
    },
    {
      "lng": -70.987694,
      "lat": 42.416696
    },
    {
      "lng": -70.990595,
      "lat": 42.407098
    },
    {
      "lng": -70.989195,
      "lat": 42.402598
    },
    {
      "lng": -70.985068,
      "lat": 42.402041
    },
    {
      "lng": -70.983426,
      "lat": 42.396246
    },
    {
      "lng": -70.980336,
      "lat": 42.391513
    },
    {
      "lng": -70.972706,
      "lat": 42.389968
    },
    {
      "lng": -70.970195,
      "lat": 42.388036
    },
    {
      "lng": -70.97174,
      "lat": 42.387071
    },
    {
      "lng": -70.972513,
      "lat": 42.385042
    },
    {
      "lng": -70.972706,
      "lat": 42.381759
    },
    {
      "lng": -70.972223,
      "lat": 42.377316
    },
    {
      "lng": -70.960798,
      "lat": 42.360648
    },
    {
      "lng": -70.953292,
      "lat": 42.349698
    },
    {
      "lng": -70.953022,
      "lat": 42.343973
    },
    {
      "lng": -70.963578,
      "lat": 42.34686
    },
    {
      "lng": -70.972418,
      "lat": 42.353875
    },
    {
      "lng": -70.974897,
      "lat": 42.355843
    },
    {
      "lng": -70.979927,
      "lat": 42.356382
    },
    {
      "lng": -70.982282,
      "lat": 42.35592
    },
    {
      "lng": -70.998253,
      "lat": 42.352788
    },
    {
      "lng": -71.006877,
      "lat": 42.347039
    },
    {
      "lng": -71.010146,
      "lat": 42.339234
    },
    {
      "lng": -71.011804,
      "lat": 42.335274
    },
    {
      "lng": -71.01568,
      "lat": 42.326019
    },
    {
      "lng": -71.013165,
      "lat": 42.315419
    },
    {
      "lng": -71.005399,
      "lat": 42.307196
    },
    {
      "lng": -71.041694,
      "lat": 42.305298
    },
    {
      "lng": -71.035294,
      "lat": 42.288798
    },
    {
      "lng": -71.03908,
      "lat": 42.283966
    },
    {
      "lng": -71.040494,
      "lat": 42.281898
    },
    {
      "lng": -71.041594,
      "lat": 42.278098
    },
    {
      "lng": -71.042794,
      "lat": 42.276998
    }
  ],
  "Worcester County MA": [
    {
      "lng": -72.124526,
      "lat": 42.717636
    },
    {
      "lng": -71.981402,
      "lat": 42.713294
    },
    {
      "lng": -71.928811,
      "lat": 42.712234
    },
    {
      "lng": -71.898716,
      "lat": 42.71142
    },
    {
      "lng": -71.897089,
      "lat": 42.703826
    },
    {
      "lng": -71.85782,
      "lat": 42.674987
    },
    {
      "lng": -71.85841,
      "lat": 42.63384
    },
    {
      "lng": -71.844843,
      "lat": 42.637985
    },
    {
      "lng": -71.775322,
      "lat": 42.636663
    },
    {
      "lng": -71.775742,
      "lat": 42.644216
    },
    {
      "lng": -71.664614,
      "lat": 42.611589
    },
    {
      "lng": -71.67773,
      "lat": 42.539397
    },
    {
      "lng": -71.67898,
      "lat": 42.530351
    },
    {
      "lng": -71.635812,
      "lat": 42.524091
    },
    {
      "lng": -71.636079,
      "lat": 42.539924
    },
    {
      "lng": -71.620039,
      "lat": 42.55245
    },
    {
      "lng": -71.594643,
      "lat": 42.54337
    },
    {
      "lng": -71.580287,
      "lat": 42.550467
    },
    {
      "lng": -71.538949,
      "lat": 42.543069
    },
    {
      "lng": -71.531476,
      "lat": 42.520487
    },
    {
      "lng": -71.560367,
      "lat": 42.47435
    },
    {
      "lng": -71.543297,
      "lat": 42.466451
    },
    {
      "lng": -71.559046,
      "lat": 42.411981
    },
    {
      "lng": -71.604251,
      "lat": 42.397703
    },
    {
      "lng": -71.580043,
      "lat": 42.386949
    },
    {
      "lng": -71.603187,
      "lat": 42.367329
    },
    {
      "lng": -71.610007,
      "lat": 42.357403
    },
    {
      "lng": -71.624702,
      "lat": 42.350465
    },
    {
      "lng": -71.585168,
      "lat": 42.310977
    },
    {
      "lng": -71.551126,
      "lat": 42.326395
    },
    {
      "lng": -71.486768,
      "lat": 42.330075
    },
    {
      "lng": -71.497046,
      "lat": 42.289829
    },
    {
      "lng": -71.513048,
      "lat": 42.267148
    },
    {
      "lng": -71.562194,
      "lat": 42.267651
    },
    {
      "lng": -71.586759,
      "lat": 42.259545
    },
    {
      "lng": -71.599318,
      "lat": 42.225959
    },
    {
      "lng": -71.58291,
      "lat": 42.195559
    },
    {
      "lng": -71.502626,
      "lat": 42.191416
    },
    {
      "lng": -71.497378,
      "lat": 42.166643
    },
    {
      "lng": -71.478119,
      "lat": 42.156782
    },
    {
      "lng": -71.478521,
      "lat": 42.131421
    },
    {
      "lng": -71.50091,
      "lat": 42.117041
    },
    {
      "lng": -71.498258,
      "lat": 42.01722
    },
    {
      "lng": -71.499905,
      "lat": 42.017198
    },
    {
      "lng": -71.500905,
      "lat": 42.017098
    },
    {
      "lng": -71.527306,
      "lat": 42.015098
    },
    {
      "lng": -71.527606,
      "lat": 42.014998
    },
    {
      "lng": -71.559439,
      "lat": 42.014342
    },
    {
      "lng": -71.576908,
      "lat": 42.014098
    },
    {
      "lng": -71.76601,
      "lat": 42.009745
    },
    {
      "lng": -71.799242,
      "lat": 42.008065
    },
    {
      "lng": -71.80065,
      "lat": 42.023569
    },
    {
      "lng": -71.89078,
      "lat": 42.024368
    },
    {
      "lng": -71.987326,
      "lat": 42.02688
    },
    {
      "lng": -72.063496,
      "lat": 42.027347
    },
    {
      "lng": -72.102162,
      "lat": 42.028899
    },
    {
      "lng": -72.135687,
      "lat": 42.030245
    },
    {
      "lng": -72.135715,
      "lat": 42.030245
    },
    {
      "lng": -72.135023,
      "lat": 42.161708
    },
    {
      "lng": -72.199304,
      "lat": 42.153588
    },
    {
      "lng": -72.200626,
      "lat": 42.161287
    },
    {
      "lng": -72.263876,
      "lat": 42.183885
    },
    {
      "lng": -72.262792,
      "lat": 42.202534
    },
    {
      "lng": -72.221218,
      "lat": 42.245252
    },
    {
      "lng": -72.218068,
      "lat": 42.248605
    },
    {
      "lng": -72.214821,
      "lat": 42.249041
    },
    {
      "lng": -72.214584,
      "lat": 42.247571
    },
    {
      "lng": -72.21046,
      "lat": 42.247205
    },
    {
      "lng": -72.211079,
      "lat": 42.251262
    },
    {
      "lng": -72.217879,
      "lat": 42.270089
    },
    {
      "lng": -72.203363,
      "lat": 42.291162
    },
    {
      "lng": -72.210795,
      "lat": 42.31138
    },
    {
      "lng": -72.274639,
      "lat": 42.301963
    },
    {
      "lng": -72.284239,
      "lat": 42.352057
    },
    {
      "lng": -72.314599,
      "lat": 42.343526
    },
    {
      "lng": -72.310236,
      "lat": 42.38753
    },
    {
      "lng": -72.315994,
      "lat": 42.394544
    },
    {
      "lng": -72.306284,
      "lat": 42.420114
    },
    {
      "lng": -72.283408,
      "lat": 42.441196
    },
    {
      "lng": -72.291424,
      "lat": 42.479495
    },
    {
      "lng": -72.244952,
      "lat": 42.513552
    },
    {
      "lng": -72.26922,
      "lat": 42.533403
    },
    {
      "lng": -72.276452,
      "lat": 42.57685
    },
    {
      "lng": -72.261321,
      "lat": 42.575868
    },
    {
      "lng": -72.267064,
      "lat": 42.600813
    },
    {
      "lng": -72.254713,
      "lat": 42.611633
    },
    {
      "lng": -72.227832,
      "lat": 42.615788
    },
    {
      "lng": -72.224839,
      "lat": 42.638981
    },
    {
      "lng": -72.22948,
      "lat": 42.662666
    },
    {
      "lng": -72.271912,
      "lat": 42.674304
    },
    {
      "lng": -72.282981,
      "lat": 42.721557
    },
    {
      "lng": -72.124526,
      "lat": 42.717636
    }
  ],
  "Mecklenburg County NC": [
    {
      "lng": -80.884887,
      "lat": 35.05351
    },
    {
      "lng": -80.906416,
      "lat": 35.076616
    },
    {
      "lng": -80.906553,
      "lat": 35.076763
    },
    {
      "lng": -80.93495,
      "lat": 35.107409
    },
    {
      "lng": -80.95787,
      "lat": 35.092639
    },
    {
      "lng": -80.98416,
      "lat": 35.077568
    },
    {
      "lng": -81.041489,
      "lat": 35.044703
    },
    {
      "lng": -81.050018,
      "lat": 35.055246
    },
    {
      "lng": -81.055695,
      "lat": 35.060121
    },
    {
      "lng": -81.057648,
      "lat": 35.062433
    },
    {
      "lng": -81.058029,
      "lat": 35.07319
    },
    {
      "lng": -81.057236,
      "lat": 35.086129
    },
    {
      "lng": -81.052078,
      "lat": 35.096276
    },
    {
      "lng": -81.050079,
      "lat": 35.098817
    },
    {
      "lng": -81.046524,
      "lat": 35.100617
    },
    {
      "lng": -81.037369,
      "lat": 35.102541
    },
    {
      "lng": -81.034958,
      "lat": 35.104105
    },
    {
      "lng": -81.032806,
      "lat": 35.108049
    },
    {
      "lng": -81.032471,
      "lat": 35.110033
    },
    {
      "lng": -81.033005,
      "lat": 35.113747
    },
    {
      "lng": -81.036759,
      "lat": 35.122552
    },
    {
      "lng": -81.038968,
      "lat": 35.126299
    },
    {
      "lng": -81.05042,
      "lat": 35.131048
    },
    {
      "lng": -81.051037,
      "lat": 35.131654
    },
    {
      "lng": -81.051204,
      "lat": 35.133237
    },
    {
      "lng": -81.047826,
      "lat": 35.143743
    },
    {
      "lng": -81.047091,
      "lat": 35.145157
    },
    {
      "lng": -81.044391,
      "lat": 35.147918
    },
    {
      "lng": -81.043407,
      "lat": 35.14839
    },
    {
      "lng": -81.04287,
      "lat": 35.149248
    },
    {
      "lng": -81.005851,
      "lat": 35.156562
    },
    {
      "lng": -81.005061,
      "lat": 35.189821
    },
    {
      "lng": -81.013956,
      "lat": 35.220588
    },
    {
      "lng": -81.008979,
      "lat": 35.24574
    },
    {
      "lng": -81.01514,
      "lat": 35.268027
    },
    {
      "lng": -81.001412,
      "lat": 35.304522
    },
    {
      "lng": -80.980991,
      "lat": 35.331397
    },
    {
      "lng": -80.984446,
      "lat": 35.340708
    },
    {
      "lng": -80.96932,
      "lat": 35.35099
    },
    {
      "lng": -80.945246,
      "lat": 35.35015
    },
    {
      "lng": -80.922882,
      "lat": 35.360334
    },
    {
      "lng": -80.950939,
      "lat": 35.366876
    },
    {
      "lng": -80.958195,
      "lat": 35.374894
    },
    {
      "lng": -80.976226,
      "lat": 35.364219
    },
    {
      "lng": -80.985694,
      "lat": 35.371817
    },
    {
      "lng": -80.987018,
      "lat": 35.378412
    },
    {
      "lng": -80.954726,
      "lat": 35.39394
    },
    {
      "lng": -80.955388,
      "lat": 35.400833
    },
    {
      "lng": -80.958636,
      "lat": 35.431697
    },
    {
      "lng": -80.94274,
      "lat": 35.453417
    },
    {
      "lng": -80.94703,
      "lat": 35.487699
    },
    {
      "lng": -80.909825,
      "lat": 35.515103
    },
    {
      "lng": -80.865882,
      "lat": 35.511816
    },
    {
      "lng": -80.784339,
      "lat": 35.50584
    },
    {
      "lng": -80.787942,
      "lat": 35.493135
    },
    {
      "lng": -80.764909,
      "lat": 35.440968
    },
    {
      "lng": -80.752507,
      "lat": 35.41438
    },
    {
      "lng": -80.764255,
      "lat": 35.400226
    },
    {
      "lng": -80.719625,
      "lat": 35.362842
    },
    {
      "lng": -80.708556,
      "lat": 35.355213
    },
    {
      "lng": -80.69362,
      "lat": 35.346806
    },
    {
      "lng": -80.667274,
      "lat": 35.269014
    },
    {
      "lng": -80.665835,
      "lat": 35.268181
    },
    {
      "lng": -80.550297,
      "lat": 35.208381
    },
    {
      "lng": -80.71053,
      "lat": 35.080126
    },
    {
      "lng": -80.774292,
      "lat": 35.032877
    },
    {
      "lng": -80.804121,
      "lat": 35.027843
    },
    {
      "lng": -80.805301,
      "lat": 35.025961
    },
    {
      "lng": -80.840383,
      "lat": 35.001636
    },
    {
      "lng": -80.884887,
      "lat": 35.05351
    }
  ],
  "Richland County SC": [
    {
      "lng": -81.059715,
      "lat": 34.005253
    },
    {
      "lng": -81.073315,
      "lat": 34.006553
    },
    {
      "lng": -81.103754,
      "lat": 34.023461
    },
    {
      "lng": -81.12806,
      "lat": 34.058488
    },
    {
      "lng": -81.174039,
      "lat": 34.090498
    },
    {
      "lng": -81.201834,
      "lat": 34.097167
    },
    {
      "lng": -81.253754,
      "lat": 34.102153
    },
    {
      "lng": -81.275845,
      "lat": 34.097381
    },
    {
      "lng": -81.315037,
      "lat": 34.146141
    },
    {
      "lng": -81.299744,
      "lat": 34.165373
    },
    {
      "lng": -81.317266,
      "lat": 34.186243
    },
    {
      "lng": -81.338961,
      "lat": 34.197587
    },
    {
      "lng": -81.345328,
      "lat": 34.20503
    },
    {
      "lng": -81.316911,
      "lat": 34.239458
    },
    {
      "lng": -81.284113,
      "lat": 34.233033
    },
    {
      "lng": -81.251273,
      "lat": 34.202946
    },
    {
      "lng": -81.226412,
      "lat": 34.205687
    },
    {
      "lng": -81.178293,
      "lat": 34.174552
    },
    {
      "lng": -81.179508,
      "lat": 34.186644
    },
    {
      "lng": -81.168409,
      "lat": 34.197443
    },
    {
      "lng": -81.181197,
      "lat": 34.220215
    },
    {
      "lng": -81.095863,
      "lat": 34.213872
    },
    {
      "lng": -81.069342,
      "lat": 34.232418
    },
    {
      "lng": -81.039224,
      "lat": 34.232537
    },
    {
      "lng": -80.961986,
      "lat": 34.25201
    },
    {
      "lng": -80.825921,
      "lat": 34.26876
    },
    {
      "lng": -80.869733,
      "lat": 34.182389
    },
    {
      "lng": -80.851379,
      "lat": 34.174071
    },
    {
      "lng": -80.719318,
      "lat": 34.068972
    },
    {
      "lng": -80.70359,
      "lat": 34.080985
    },
    {
      "lng": -80.692965,
      "lat": 34.08128
    },
    {
      "lng": -80.616186,
      "lat": 34.099605
    },
    {
      "lng": -80.617015,
      "lat": 34.094873
    },
    {
      "lng": -80.628852,
      "lat": 34.077389
    },
    {
      "lng": -80.626607,
      "lat": 34.071338
    },
    {
      "lng": -80.613367,
      "lat": 34.060224
    },
    {
      "lng": -80.607584,
      "lat": 34.043648
    },
    {
      "lng": -80.605451,
      "lat": 34.027073
    },
    {
      "lng": -80.6273,
      "lat": 34.008319
    },
    {
      "lng": -80.636158,
      "lat": 34.004172
    },
    {
      "lng": -80.643347,
      "lat": 33.99625
    },
    {
      "lng": -80.637733,
      "lat": 33.98069
    },
    {
      "lng": -80.626579,
      "lat": 33.9662
    },
    {
      "lng": -80.619426,
      "lat": 33.963153
    },
    {
      "lng": -80.62039,
      "lat": 33.958829
    },
    {
      "lng": -80.622647,
      "lat": 33.955107
    },
    {
      "lng": -80.628145,
      "lat": 33.947667
    },
    {
      "lng": -80.623785,
      "lat": 33.942336
    },
    {
      "lng": -80.62406,
      "lat": 33.934633
    },
    {
      "lng": -80.631582,
      "lat": 33.922589
    },
    {
      "lng": -80.625725,
      "lat": 33.900338
    },
    {
      "lng": -80.619779,
      "lat": 33.895437
    },
    {
      "lng": -80.616596,
      "lat": 33.890168
    },
    {
      "lng": -80.620495,
      "lat": 33.888683
    },
    {
      "lng": -80.623114,
      "lat": 33.883891
    },
    {
      "lng": -80.622574,
      "lat": 33.877365
    },
    {
      "lng": -80.623933,
      "lat": 33.863433
    },
    {
      "lng": -80.63043,
      "lat": 33.857588
    },
    {
      "lng": -80.628233,
      "lat": 33.845839
    },
    {
      "lng": -80.620318,
      "lat": 33.839439
    },
    {
      "lng": -80.617791,
      "lat": 33.827387
    },
    {
      "lng": -80.612069,
      "lat": 33.812914
    },
    {
      "lng": -80.605259,
      "lat": 33.810206
    },
    {
      "lng": -80.60291,
      "lat": 33.79995
    },
    {
      "lng": -80.600549,
      "lat": 33.790064
    },
    {
      "lng": -80.59976,
      "lat": 33.784607
    },
    {
      "lng": -80.603404,
      "lat": 33.770373
    },
    {
      "lng": -80.606724,
      "lat": 33.761771
    },
    {
      "lng": -80.613681,
      "lat": 33.750934
    },
    {
      "lng": -80.620107,
      "lat": 33.743237
    },
    {
      "lng": -80.624809,
      "lat": 33.745128
    },
    {
      "lng": -80.640306,
      "lat": 33.750752
    },
    {
      "lng": -80.655111,
      "lat": 33.760562
    },
    {
      "lng": -80.656258,
      "lat": 33.765721
    },
    {
      "lng": -80.669743,
      "lat": 33.767364
    },
    {
      "lng": -80.681285,
      "lat": 33.760242
    },
    {
      "lng": -80.689368,
      "lat": 33.758155
    },
    {
      "lng": -80.702873,
      "lat": 33.758856
    },
    {
      "lng": -80.706137,
      "lat": 33.767873
    },
    {
      "lng": -80.713176,
      "lat": 33.7683
    },
    {
      "lng": -80.721686,
      "lat": 33.764854
    },
    {
      "lng": -80.730005,
      "lat": 33.760389
    },
    {
      "lng": -80.739224,
      "lat": 33.767925
    },
    {
      "lng": -80.74151,
      "lat": 33.773407
    },
    {
      "lng": -80.749811,
      "lat": 33.769573
    },
    {
      "lng": -80.747786,
      "lat": 33.766026
    },
    {
      "lng": -80.747337,
      "lat": 33.761742
    },
    {
      "lng": -80.756271,
      "lat": 33.766836
    },
    {
      "lng": -80.777335,
      "lat": 33.765104
    },
    {
      "lng": -80.805096,
      "lat": 33.774003
    },
    {
      "lng": -80.825374,
      "lat": 33.780942
    },
    {
      "lng": -80.857829,
      "lat": 33.801574
    },
    {
      "lng": -80.905919,
      "lat": 33.809708
    },
    {
      "lng": -80.922888,
      "lat": 33.830765
    },
    {
      "lng": -80.97776,
      "lat": 33.848521
    },
    {
      "lng": -80.996574,
      "lat": 33.873808
    },
    {
      "lng": -81.01233,
      "lat": 33.88008
    },
    {
      "lng": -81.008754,
      "lat": 33.904102
    },
    {
      "lng": -81.029214,
      "lat": 33.916454
    },
    {
      "lng": -81.017014,
      "lat": 33.930855
    },
    {
      "lng": -81.059715,
      "lat": 34.005253
    }
  ],
  "Travis County TX": [
    {
      "lng": -97.409875,
      "lat": 30.351329
    },
    {
      "lng": -97.486329,
      "lat": 30.220528
    },
    {
      "lng": -97.492679,
      "lat": 30.209946
    },
    {
      "lng": -97.649449,
      "lat": 30.067866
    },
    {
      "lng": -97.655257,
      "lat": 30.072907
    },
    {
      "lng": -97.710215,
      "lat": 30.024499
    },
    {
      "lng": -97.98469,
      "lat": 30.222012
    },
    {
      "lng": -98.011253,
      "lat": 30.242288
    },
    {
      "lng": -98.172977,
      "lat": 30.356312
    },
    {
      "lng": -98.125556,
      "lat": 30.426186
    },
    {
      "lng": -98.097709,
      "lat": 30.467626
    },
    {
      "lng": -98.097778,
      "lat": 30.498058
    },
    {
      "lng": -98.123111,
      "lat": 30.484723
    },
    {
      "lng": -98.12342,
      "lat": 30.486482
    },
    {
      "lng": -98.049886,
      "lat": 30.624155
    },
    {
      "lng": -98.036495,
      "lat": 30.611726
    },
    {
      "lng": -98.012741,
      "lat": 30.616767
    },
    {
      "lng": -98.006276,
      "lat": 30.627516
    },
    {
      "lng": -97.9924,
      "lat": 30.609494
    },
    {
      "lng": -97.977867,
      "lat": 30.622114
    },
    {
      "lng": -97.956734,
      "lat": 30.628249
    },
    {
      "lng": -97.934809,
      "lat": 30.610286
    },
    {
      "lng": -97.917063,
      "lat": 30.604871
    },
    {
      "lng": -97.915123,
      "lat": 30.580567
    },
    {
      "lng": -97.926985,
      "lat": 30.567654
    },
    {
      "lng": -97.902456,
      "lat": 30.571328
    },
    {
      "lng": -97.867866,
      "lat": 30.546499
    },
    {
      "lng": -97.871416,
      "lat": 30.522714
    },
    {
      "lng": -97.855765,
      "lat": 30.507401
    },
    {
      "lng": -97.848384,
      "lat": 30.472662
    },
    {
      "lng": -97.813287,
      "lat": 30.4474
    },
    {
      "lng": -97.779387,
      "lat": 30.438401
    },
    {
      "lng": -97.775211,
      "lat": 30.429993
    },
    {
      "lng": -97.753688,
      "lat": 30.433396
    },
    {
      "lng": -97.746686,
      "lat": 30.449404
    },
    {
      "lng": -97.688784,
      "lat": 30.461401
    },
    {
      "lng": -97.682893,
      "lat": 30.480066
    },
    {
      "lng": -97.652395,
      "lat": 30.475275
    },
    {
      "lng": -97.596236,
      "lat": 30.501513
    },
    {
      "lng": -97.576167,
      "lat": 30.501799
    },
    {
      "lng": -97.54412,
      "lat": 30.47961
    },
    {
      "lng": -97.528151,
      "lat": 30.475434
    },
    {
      "lng": -97.512247,
      "lat": 30.48521
    },
    {
      "lng": -97.466953,
      "lat": 30.46412
    },
    {
      "lng": -97.445628,
      "lat": 30.461404
    },
    {
      "lng": -97.415953,
      "lat": 30.437426
    },
    {
      "lng": -97.392539,
      "lat": 30.437365
    },
    {
      "lng": -97.373446,
      "lat": 30.416953
    },
    {
      "lng": -97.369539,
      "lat": 30.419563
    },
    {
      "lng": -97.409875,
      "lat": 30.351329
    }
  ],
  "Bastrop County TX": [
    {
      "lng": -97.409875,
      "lat": 30.351329
    },
    {
      "lng": -97.369539,
      "lat": 30.419563
    },
    {
      "lng": -97.334463,
      "lat": 30.402843
    },
    {
      "lng": -97.199578,
      "lat": 30.337833
    },
    {
      "lng": -97.081834,
      "lat": 30.259357
    },
    {
      "lng": -97.04821,
      "lat": 30.137947
    },
    {
      "lng": -97.024461,
      "lat": 30.051435
    },
    {
      "lng": -97.315823,
      "lat": 29.786541
    },
    {
      "lng": -97.649449,
      "lat": 30.067866
    },
    {
      "lng": -97.492679,
      "lat": 30.209946
    },
    {
      "lng": -97.486329,
      "lat": 30.220528
    },
    {
      "lng": -97.409875,
      "lat": 30.351329
    }
  ],
  "Caldwell County TX": [
    {
      "lng": -97.317893,
      "lat": 29.784658
    },
    {
      "lng": -97.597743,
      "lat": 29.630718
    },
    {
      "lng": -97.617497,
      "lat": 29.633553
    },
    {
      "lng": -97.617477,
      "lat": 29.645105
    },
    {
      "lng": -97.629429,
      "lat": 29.639783
    },
    {
      "lng": -97.633176,
      "lat": 29.649863
    },
    {
      "lng": -97.632942,
      "lat": 29.653842
    },
    {
      "lng": -97.639418,
      "lat": 29.652884
    },
    {
      "lng": -97.648966,
      "lat": 29.654539
    },
    {
      "lng": -97.653251,
      "lat": 29.658648
    },
    {
      "lng": -97.648104,
      "lat": 29.657527
    },
    {
      "lng": -97.649283,
      "lat": 29.663341
    },
    {
      "lng": -97.651902,
      "lat": 29.666575
    },
    {
      "lng": -97.656849,
      "lat": 29.664672
    },
    {
      "lng": -97.662647,
      "lat": 29.667348
    },
    {
      "lng": -97.671344,
      "lat": 29.665691
    },
    {
      "lng": -97.676299,
      "lat": 29.668164
    },
    {
      "lng": -97.682721,
      "lat": 29.664204
    },
    {
      "lng": -97.68665,
      "lat": 29.670152
    },
    {
      "lng": -97.691343,
      "lat": 29.671977
    },
    {
      "lng": -97.695331,
      "lat": 29.671172
    },
    {
      "lng": -97.70346,
      "lat": 29.672232
    },
    {
      "lng": -97.70521,
      "lat": 29.67571
    },
    {
      "lng": -97.706562,
      "lat": 29.682791
    },
    {
      "lng": -97.71125,
      "lat": 29.68181
    },
    {
      "lng": -97.721178,
      "lat": 29.682329
    },
    {
      "lng": -97.730019,
      "lat": 29.689017
    },
    {
      "lng": -97.739473,
      "lat": 29.696499
    },
    {
      "lng": -97.736107,
      "lat": 29.704749
    },
    {
      "lng": -97.740185,
      "lat": 29.712461
    },
    {
      "lng": -97.745088,
      "lat": 29.712236
    },
    {
      "lng": -97.757844,
      "lat": 29.716354
    },
    {
      "lng": -97.76513,
      "lat": 29.716217
    },
    {
      "lng": -97.763536,
      "lat": 29.721766
    },
    {
      "lng": -97.760883,
      "lat": 29.726472
    },
    {
      "lng": -97.771424,
      "lat": 29.733642
    },
    {
      "lng": -97.770991,
      "lat": 29.741813
    },
    {
      "lng": -97.776296,
      "lat": 29.74553
    },
    {
      "lng": -97.779968,
      "lat": 29.749377
    },
    {
      "lng": -97.780663,
      "lat": 29.7536
    },
    {
      "lng": -97.781724,
      "lat": 29.757831
    },
    {
      "lng": -97.789707,
      "lat": 29.760115
    },
    {
      "lng": -97.792906,
      "lat": 29.7559
    },
    {
      "lng": -97.801125,
      "lat": 29.753991
    },
    {
      "lng": -97.800245,
      "lat": 29.760871
    },
    {
      "lng": -97.802919,
      "lat": 29.766695
    },
    {
      "lng": -97.807283,
      "lat": 29.769332
    },
    {
      "lng": -97.808778,
      "lat": 29.774545
    },
    {
      "lng": -97.80623,
      "lat": 29.777379
    },
    {
      "lng": -97.810904,
      "lat": 29.779247
    },
    {
      "lng": -97.814058,
      "lat": 29.781756
    },
    {
      "lng": -97.820766,
      "lat": 29.787198
    },
    {
      "lng": -97.823336,
      "lat": 29.783927
    },
    {
      "lng": -97.827894,
      "lat": 29.780188
    },
    {
      "lng": -97.831582,
      "lat": 29.783329
    },
    {
      "lng": -97.830373,
      "lat": 29.789346
    },
    {
      "lng": -97.837845,
      "lat": 29.796478
    },
    {
      "lng": -97.842317,
      "lat": 29.804415
    },
    {
      "lng": -97.845296,
      "lat": 29.807455
    },
    {
      "lng": -97.843264,
      "lat": 29.812198
    },
    {
      "lng": -97.840291,
      "lat": 29.818215
    },
    {
      "lng": -97.837366,
      "lat": 29.825033
    },
    {
      "lng": -97.842447,
      "lat": 29.832191
    },
    {
      "lng": -97.847336,
      "lat": 29.842449
    },
    {
      "lng": -97.856882,
      "lat": 29.849597
    },
    {
      "lng": -97.860077,
      "lat": 29.852778
    },
    {
      "lng": -97.866492,
      "lat": 29.855056
    },
    {
      "lng": -97.872546,
      "lat": 29.854464
    },
    {
      "lng": -97.875259,
      "lat": 29.858208
    },
    {
      "lng": -97.874492,
      "lat": 29.859571
    },
    {
      "lng": -97.899238,
      "lat": 29.857583
    },
    {
      "lng": -97.893896,
      "lat": 29.883734
    },
    {
      "lng": -97.849178,
      "lat": 29.916
    },
    {
      "lng": -97.792593,
      "lat": 29.945057
    },
    {
      "lng": -97.761332,
      "lat": 29.987319
    },
    {
      "lng": -97.710215,
      "lat": 30.024499
    },
    {
      "lng": -97.655257,
      "lat": 30.072907
    },
    {
      "lng": -97.649449,
      "lat": 30.067866
    },
    {
      "lng": -97.315823,
      "lat": 29.786541
    },
    {
      "lng": -97.317893,
      "lat": 29.784658
    }
  ],
  "Wake County NC": [
    {
      "lng": -78.69793,
      "lat": 36.012306
    },
    {
      "lng": -78.719592,
      "lat": 36.029435
    },
    {
      "lng": -78.750668,
      "lat": 36.030847
    },
    {
      "lng": -78.749,
      "lat": 36.071246
    },
    {
      "lng": -78.683318,
      "lat": 36.074492
    },
    {
      "lng": -78.546497,
      "lat": 36.021804
    },
    {
      "lng": -78.486853,
      "lat": 36.000145
    },
    {
      "lng": -78.426648,
      "lat": 35.974917
    },
    {
      "lng": -78.394463,
      "lat": 35.936938
    },
    {
      "lng": -78.353448,
      "lat": 35.931006
    },
    {
      "lng": -78.350327,
      "lat": 35.909495
    },
    {
      "lng": -78.324654,
      "lat": 35.895988
    },
    {
      "lng": -78.30757,
      "lat": 35.89662
    },
    {
      "lng": -78.282396,
      "lat": 35.872225
    },
    {
      "lng": -78.254903,
      "lat": 35.81773
    },
    {
      "lng": -78.387079,
      "lat": 35.743625
    },
    {
      "lng": -78.473733,
      "lat": 35.701551
    },
    {
      "lng": -78.566633,
      "lat": 35.62895
    },
    {
      "lng": -78.708629,
      "lat": 35.519081
    },
    {
      "lng": -78.913296,
      "lat": 35.583064
    },
    {
      "lng": -78.995054,
      "lat": 35.610233
    },
    {
      "lng": -78.971335,
      "lat": 35.675614
    },
    {
      "lng": -78.909427,
      "lat": 35.842941
    },
    {
      "lng": -78.90617,
      "lat": 35.867912
    },
    {
      "lng": -78.831781,
      "lat": 35.867314
    },
    {
      "lng": -78.806052,
      "lat": 35.927862
    },
    {
      "lng": -78.759237,
      "lat": 35.918185
    },
    {
      "lng": -78.718679,
      "lat": 35.95806
    },
    {
      "lng": -78.69793,
      "lat": 36.012306
    }
  ]
};

export default countyPolygons;
